var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a3, b3) => {
  for (var prop in b3 || (b3 = {}))
    if (__hasOwnProp.call(b3, prop))
      __defNormalProp(a3, prop, b3[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b3)) {
      if (__propIsEnum.call(b3, prop))
        __defNormalProp(a3, prop, b3[prop]);
    }
  return a3;
};
var __spreadProps = (a3, b3) => __defProps(a3, __getOwnPropDescs(b3));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

// node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/errors.js
var require_errors = __commonJS({
  "node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/errors.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.errorMessages = exports.ErrorType = void 0;
    var ErrorType;
    (function(ErrorType2) {
      ErrorType2["MalformedUnicode"] = "MALFORMED_UNICODE";
      ErrorType2["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
      ErrorType2["CodePointLimit"] = "CODE_POINT_LIMIT";
      ErrorType2["OctalDeprecation"] = "OCTAL_DEPRECATION";
      ErrorType2["EndOfString"] = "END_OF_STRING";
    })(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
    exports.errorMessages = /* @__PURE__ */ new Map([
      [ErrorType.MalformedUnicode, "malformed Unicode character escape sequence"],
      [
        ErrorType.MalformedHexadecimal,
        "malformed hexadecimal character escape sequence"
      ],
      [
        ErrorType.CodePointLimit,
        "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
      ],
      [
        ErrorType.OctalDeprecation,
        '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
      ],
      [ErrorType.EndOfString, "malformed escape sequence at end of string"]
    ]);
  }
});

// node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/index.js
var require_dist = __commonJS({
  "node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.unraw = exports.errorMessages = exports.ErrorType = void 0;
    var errors_1 = require_errors();
    Object.defineProperty(exports, "ErrorType", { enumerable: true, get: function() {
      return errors_1.ErrorType;
    } });
    Object.defineProperty(exports, "errorMessages", { enumerable: true, get: function() {
      return errors_1.errorMessages;
    } });
    function parseHexToInt(hex) {
      const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
      return isOnlyHexChars ? parseInt(hex, 16) : NaN;
    }
    function validateAndParseHex(hex, errorName, enforcedLength) {
      const parsedHex = parseHexToInt(hex);
      if (Number.isNaN(parsedHex) || enforcedLength !== void 0 && enforcedLength !== hex.length) {
        throw new SyntaxError(errors_1.errorMessages.get(errorName));
      }
      return parsedHex;
    }
    function parseHexadecimalCode(code) {
      const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedHexadecimal, 2);
      return String.fromCharCode(parsedCode);
    }
    function parseUnicodeCode(code, surrogateCode) {
      const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedUnicode, 4);
      if (surrogateCode !== void 0) {
        const parsedSurrogateCode = validateAndParseHex(surrogateCode, errors_1.ErrorType.MalformedUnicode, 4);
        return String.fromCharCode(parsedCode, parsedSurrogateCode);
      }
      return String.fromCharCode(parsedCode);
    }
    function isCurlyBraced(text) {
      return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
    }
    function parseUnicodeCodePointCode(codePoint) {
      if (!isCurlyBraced(codePoint)) {
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.MalformedUnicode));
      }
      const withoutBraces = codePoint.slice(1, -1);
      const parsedCode = validateAndParseHex(withoutBraces, errors_1.ErrorType.MalformedUnicode);
      try {
        return String.fromCodePoint(parsedCode);
      } catch (err) {
        throw err instanceof RangeError ? new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.CodePointLimit)) : err;
      }
    }
    function parseOctalCode(code, error = false) {
      if (error) {
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.OctalDeprecation));
      }
      const parsedCode = parseInt(code, 8);
      return String.fromCharCode(parsedCode);
    }
    var singleCharacterEscapes = /* @__PURE__ */ new Map([
      ["b", "\b"],
      ["f", "\f"],
      ["n", "\n"],
      ["r", "\r"],
      ["t", "	"],
      ["v", "\v"],
      ["0", "\0"]
    ]);
    function parseSingleCharacterCode(code) {
      return singleCharacterEscapes.get(code) || code;
    }
    var escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
    function unraw2(raw, allowOctals = false) {
      return raw.replace(escapeMatch, function(_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
        if (backslash !== void 0) {
          return "\\";
        }
        if (hex !== void 0) {
          return parseHexadecimalCode(hex);
        }
        if (codePoint !== void 0) {
          return parseUnicodeCodePointCode(codePoint);
        }
        if (unicodeWithSurrogate !== void 0) {
          return parseUnicodeCode(unicodeWithSurrogate, surrogate);
        }
        if (unicode !== void 0) {
          return parseUnicodeCode(unicode);
        }
        if (octal === "0") {
          return "\0";
        }
        if (octal !== void 0) {
          return parseOctalCode(octal, !allowOctals);
        }
        if (singleCharacter !== void 0) {
          return parseSingleCharacterCode(singleCharacter);
        }
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.EndOfString));
      });
    }
    exports.unraw = unraw2;
    exports.default = unraw2;
  }
});

// node_modules/.pnpm/moo@0.5.2/node_modules/moo/moo.js
var require_moo = __commonJS({
  "node_modules/.pnpm/moo@0.5.2/node_modules/moo/moo.js"(exports, module) {
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof module === "object" && module.exports) {
        module.exports = factory();
      } else {
        root.moo = factory();
      }
    })(exports, function() {
      "use strict";
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var toString = Object.prototype.toString;
      var hasSticky = typeof new RegExp().sticky === "boolean";
      function isRegExp(o3) {
        return o3 && toString.call(o3) === "[object RegExp]";
      }
      function isObject(o3) {
        return o3 && typeof o3 === "object" && !isRegExp(o3) && !Array.isArray(o3);
      }
      function reEscape(s3) {
        return s3.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      function reGroups(s3) {
        var re = new RegExp("|" + s3);
        return re.exec("").length - 1;
      }
      function reCapture(s3) {
        return "(" + s3 + ")";
      }
      function reUnion(regexps) {
        if (!regexps.length)
          return "(?!)";
        var source = regexps.map(function(s3) {
          return "(?:" + s3 + ")";
        }).join("|");
        return "(?:" + source + ")";
      }
      function regexpOrLiteral(obj) {
        if (typeof obj === "string") {
          return "(?:" + reEscape(obj) + ")";
        } else if (isRegExp(obj)) {
          if (obj.ignoreCase)
            throw new Error("RegExp /i flag not allowed");
          if (obj.global)
            throw new Error("RegExp /g flag is implied");
          if (obj.sticky)
            throw new Error("RegExp /y flag is implied");
          if (obj.multiline)
            throw new Error("RegExp /m flag is implied");
          return obj.source;
        } else {
          throw new Error("Not a pattern: " + obj);
        }
      }
      function pad(s3, length) {
        if (s3.length > length) {
          return s3;
        }
        return Array(length - s3.length + 1).join(" ") + s3;
      }
      function lastNLines(string, numLines) {
        var position = string.length;
        var lineBreaks = 0;
        while (true) {
          var idx = string.lastIndexOf("\n", position - 1);
          if (idx === -1) {
            break;
          } else {
            lineBreaks++;
          }
          position = idx;
          if (lineBreaks === numLines) {
            break;
          }
          if (position === 0) {
            break;
          }
        }
        var startPosition = lineBreaks < numLines ? 0 : position + 1;
        return string.substring(startPosition).split("\n");
      }
      function objectToRules(object) {
        var keys2 = Object.getOwnPropertyNames(object);
        var result = [];
        for (var i3 = 0; i3 < keys2.length; i3++) {
          var key = keys2[i3];
          var thing = object[key];
          var rules = [].concat(thing);
          if (key === "include") {
            for (var j = 0; j < rules.length; j++) {
              result.push({ include: rules[j] });
            }
            continue;
          }
          var match = [];
          rules.forEach(function(rule) {
            if (isObject(rule)) {
              if (match.length)
                result.push(ruleOptions(key, match));
              result.push(ruleOptions(key, rule));
              match = [];
            } else {
              match.push(rule);
            }
          });
          if (match.length)
            result.push(ruleOptions(key, match));
        }
        return result;
      }
      function arrayToRules(array) {
        var result = [];
        for (var i3 = 0; i3 < array.length; i3++) {
          var obj = array[i3];
          if (obj.include) {
            var include = [].concat(obj.include);
            for (var j = 0; j < include.length; j++) {
              result.push({ include: include[j] });
            }
            continue;
          }
          if (!obj.type) {
            throw new Error("Rule has no type: " + JSON.stringify(obj));
          }
          result.push(ruleOptions(obj.type, obj));
        }
        return result;
      }
      function ruleOptions(type, obj) {
        if (!isObject(obj)) {
          obj = { match: obj };
        }
        if (obj.include) {
          throw new Error("Matching rules cannot also include states");
        }
        var options = {
          defaultType: type,
          lineBreaks: !!obj.error || !!obj.fallback,
          pop: false,
          next: null,
          push: null,
          error: false,
          fallback: false,
          value: null,
          type: null,
          shouldThrow: false
        };
        for (var key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            options[key] = obj[key];
          }
        }
        if (typeof options.type === "string" && type !== options.type) {
          throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')");
        }
        var match = options.match;
        options.match = Array.isArray(match) ? match : match ? [match] : [];
        options.match.sort(function(a3, b3) {
          return isRegExp(a3) && isRegExp(b3) ? 0 : isRegExp(b3) ? -1 : isRegExp(a3) ? 1 : b3.length - a3.length;
        });
        return options;
      }
      function toRules(spec) {
        return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec);
      }
      var defaultErrorRule = ruleOptions("error", { lineBreaks: true, shouldThrow: true });
      function compileRules(rules, hasStates) {
        var errorRule = null;
        var fast = /* @__PURE__ */ Object.create(null);
        var fastAllowed = true;
        var unicodeFlag = null;
        var groups = [];
        var parts = [];
        for (var i3 = 0; i3 < rules.length; i3++) {
          if (rules[i3].fallback) {
            fastAllowed = false;
          }
        }
        for (var i3 = 0; i3 < rules.length; i3++) {
          var options = rules[i3];
          if (options.include) {
            throw new Error("Inheritance is not allowed in stateless lexers");
          }
          if (options.error || options.fallback) {
            if (errorRule) {
              if (!options.fallback === !errorRule.fallback) {
                throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')");
              } else {
                throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')");
              }
            }
            errorRule = options;
          }
          var match = options.match.slice();
          if (fastAllowed) {
            while (match.length && typeof match[0] === "string" && match[0].length === 1) {
              var word = match.shift();
              fast[word.charCodeAt(0)] = options;
            }
          }
          if (options.pop || options.push || options.next) {
            if (!hasStates) {
              throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')");
            }
            if (options.fallback) {
              throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')");
            }
          }
          if (match.length === 0) {
            continue;
          }
          fastAllowed = false;
          groups.push(options);
          for (var j = 0; j < match.length; j++) {
            var obj = match[j];
            if (!isRegExp(obj)) {
              continue;
            }
            if (unicodeFlag === null) {
              unicodeFlag = obj.unicode;
            } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
              throw new Error("If one rule is /u then all must be");
            }
          }
          var pat = reUnion(match.map(regexpOrLiteral));
          var regexp = new RegExp(pat);
          if (regexp.test("")) {
            throw new Error("RegExp matches empty string: " + regexp);
          }
          var groupCount = reGroups(pat);
          if (groupCount > 0) {
            throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: \u2026 ) instead");
          }
          if (!options.lineBreaks && regexp.test("\n")) {
            throw new Error("Rule should declare lineBreaks: " + regexp);
          }
          parts.push(reCapture(pat));
        }
        var fallbackRule = errorRule && errorRule.fallback;
        var flags = hasSticky && !fallbackRule ? "ym" : "gm";
        var suffix2 = hasSticky || fallbackRule ? "" : "|";
        if (unicodeFlag === true)
          flags += "u";
        var combined = new RegExp(reUnion(parts) + suffix2, flags);
        return { regexp: combined, groups, fast, error: errorRule || defaultErrorRule };
      }
      function compile(rules) {
        var result = compileRules(toRules(rules));
        return new Lexer({ start: result }, "start");
      }
      function checkStateGroup(g3, name, map) {
        var state = g3 && (g3.push || g3.next);
        if (state && !map[state]) {
          throw new Error("Missing state '" + state + "' (in token '" + g3.defaultType + "' of state '" + name + "')");
        }
        if (g3 && g3.pop && +g3.pop !== 1) {
          throw new Error("pop must be 1 (in token '" + g3.defaultType + "' of state '" + name + "')");
        }
      }
      function compileStates(states, start) {
        var all = states.$all ? toRules(states.$all) : [];
        delete states.$all;
        var keys2 = Object.getOwnPropertyNames(states);
        if (!start)
          start = keys2[0];
        var ruleMap = /* @__PURE__ */ Object.create(null);
        for (var i3 = 0; i3 < keys2.length; i3++) {
          var key = keys2[i3];
          ruleMap[key] = toRules(states[key]).concat(all);
        }
        for (var i3 = 0; i3 < keys2.length; i3++) {
          var key = keys2[i3];
          var rules = ruleMap[key];
          var included = /* @__PURE__ */ Object.create(null);
          for (var j = 0; j < rules.length; j++) {
            var rule = rules[j];
            if (!rule.include)
              continue;
            var splice = [j, 1];
            if (rule.include !== key && !included[rule.include]) {
              included[rule.include] = true;
              var newRules = ruleMap[rule.include];
              if (!newRules) {
                throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')");
              }
              for (var k2 = 0; k2 < newRules.length; k2++) {
                var newRule = newRules[k2];
                if (rules.indexOf(newRule) !== -1)
                  continue;
                splice.push(newRule);
              }
            }
            rules.splice.apply(rules, splice);
            j--;
          }
        }
        var map = /* @__PURE__ */ Object.create(null);
        for (var i3 = 0; i3 < keys2.length; i3++) {
          var key = keys2[i3];
          map[key] = compileRules(ruleMap[key], true);
        }
        for (var i3 = 0; i3 < keys2.length; i3++) {
          var name = keys2[i3];
          var state = map[name];
          var groups = state.groups;
          for (var j = 0; j < groups.length; j++) {
            checkStateGroup(groups[j], name, map);
          }
          var fastKeys = Object.getOwnPropertyNames(state.fast);
          for (var j = 0; j < fastKeys.length; j++) {
            checkStateGroup(state.fast[fastKeys[j]], name, map);
          }
        }
        return new Lexer(map, start);
      }
      function keywordTransform(map) {
        var isMap = typeof Map !== "undefined";
        var reverseMap = isMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
        var types = Object.getOwnPropertyNames(map);
        for (var i3 = 0; i3 < types.length; i3++) {
          var tokenType = types[i3];
          var item = map[tokenType];
          var keywordList = Array.isArray(item) ? item : [item];
          keywordList.forEach(function(keyword) {
            if (typeof keyword !== "string") {
              throw new Error("keyword must be string (in keyword '" + tokenType + "')");
            }
            if (isMap) {
              reverseMap.set(keyword, tokenType);
            } else {
              reverseMap[keyword] = tokenType;
            }
          });
        }
        return function(k2) {
          return isMap ? reverseMap.get(k2) : reverseMap[k2];
        };
      }
      var Lexer = function(states, state) {
        this.startState = state;
        this.states = states;
        this.buffer = "";
        this.stack = [];
        this.reset();
      };
      Lexer.prototype.reset = function(data, info) {
        this.buffer = data || "";
        this.index = 0;
        this.line = info ? info.line : 1;
        this.col = info ? info.col : 1;
        this.queuedToken = info ? info.queuedToken : null;
        this.queuedText = info ? info.queuedText : "";
        this.queuedThrow = info ? info.queuedThrow : null;
        this.setState(info ? info.state : this.startState);
        this.stack = info && info.stack ? info.stack.slice() : [];
        return this;
      };
      Lexer.prototype.save = function() {
        return {
          line: this.line,
          col: this.col,
          state: this.state,
          stack: this.stack.slice(),
          queuedToken: this.queuedToken,
          queuedText: this.queuedText,
          queuedThrow: this.queuedThrow
        };
      };
      Lexer.prototype.setState = function(state) {
        if (!state || this.state === state)
          return;
        this.state = state;
        var info = this.states[state];
        this.groups = info.groups;
        this.error = info.error;
        this.re = info.regexp;
        this.fast = info.fast;
      };
      Lexer.prototype.popState = function() {
        this.setState(this.stack.pop());
      };
      Lexer.prototype.pushState = function(state) {
        this.stack.push(this.state);
        this.setState(state);
      };
      var eat = hasSticky ? function(re, buffer) {
        return re.exec(buffer);
      } : function(re, buffer) {
        var match = re.exec(buffer);
        if (match[0].length === 0) {
          return null;
        }
        return match;
      };
      Lexer.prototype._getGroup = function(match) {
        var groupCount = this.groups.length;
        for (var i3 = 0; i3 < groupCount; i3++) {
          if (match[i3 + 1] !== void 0) {
            return this.groups[i3];
          }
        }
        throw new Error("Cannot find token type for matched text");
      };
      function tokenToString() {
        return this.value;
      }
      Lexer.prototype.next = function() {
        var index = this.index;
        if (this.queuedGroup) {
          var token = this._token(this.queuedGroup, this.queuedText, index);
          this.queuedGroup = null;
          this.queuedText = "";
          return token;
        }
        var buffer = this.buffer;
        if (index === buffer.length) {
          return;
        }
        var group = this.fast[buffer.charCodeAt(index)];
        if (group) {
          return this._token(group, buffer.charAt(index), index);
        }
        var re = this.re;
        re.lastIndex = index;
        var match = eat(re, buffer);
        var error = this.error;
        if (match == null) {
          return this._token(error, buffer.slice(index, buffer.length), index);
        }
        var group = this._getGroup(match);
        var text = match[0];
        if (error.fallback && match.index !== index) {
          this.queuedGroup = group;
          this.queuedText = text;
          return this._token(error, buffer.slice(index, match.index), index);
        }
        return this._token(group, text, index);
      };
      Lexer.prototype._token = function(group, text, offset) {
        var lineBreaks = 0;
        if (group.lineBreaks) {
          var matchNL = /\n/g;
          var nl = 1;
          if (text === "\n") {
            lineBreaks = 1;
          } else {
            while (matchNL.exec(text)) {
              lineBreaks++;
              nl = matchNL.lastIndex;
            }
          }
        }
        var token = {
          type: typeof group.type === "function" && group.type(text) || group.defaultType,
          value: typeof group.value === "function" ? group.value(text) : text,
          text,
          toString: tokenToString,
          offset,
          lineBreaks,
          line: this.line,
          col: this.col
        };
        var size = text.length;
        this.index += size;
        this.line += lineBreaks;
        if (lineBreaks !== 0) {
          this.col = size - nl + 1;
        } else {
          this.col += size;
        }
        if (group.shouldThrow) {
          var err = new Error(this.formatError(token, "invalid syntax"));
          throw err;
        }
        if (group.pop)
          this.popState();
        else if (group.push)
          this.pushState(group.push);
        else if (group.next)
          this.setState(group.next);
        return token;
      };
      if (typeof Symbol !== "undefined" && Symbol.iterator) {
        var LexerIterator = function(lexer) {
          this.lexer = lexer;
        };
        LexerIterator.prototype.next = function() {
          var token = this.lexer.next();
          return { value: token, done: !token };
        };
        LexerIterator.prototype[Symbol.iterator] = function() {
          return this;
        };
        Lexer.prototype[Symbol.iterator] = function() {
          return new LexerIterator(this);
        };
      }
      Lexer.prototype.formatError = function(token, message) {
        if (token == null) {
          var text = this.buffer.slice(this.index);
          var token = {
            text,
            offset: this.index,
            lineBreaks: text.indexOf("\n") === -1 ? 0 : 1,
            line: this.line,
            col: this.col
          };
        }
        var numLinesAround = 2;
        var firstDisplayedLine = Math.max(token.line - numLinesAround, 1);
        var lastDisplayedLine = token.line + numLinesAround;
        var lastLineDigits = String(lastDisplayedLine).length;
        var displayedLines = lastNLines(
          this.buffer,
          this.line - token.line + numLinesAround + 1
        ).slice(0, 5);
        var errorLines = [];
        errorLines.push(message + " at line " + token.line + " col " + token.col + ":");
        errorLines.push("");
        for (var i3 = 0; i3 < displayedLines.length; i3++) {
          var line = displayedLines[i3];
          var lineNo = firstDisplayedLine + i3;
          errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
          if (lineNo === token.line) {
            errorLines.push(pad("", lastLineDigits + token.col + 1) + "^");
          }
        }
        return errorLines.join("\n");
      };
      Lexer.prototype.clone = function() {
        return new Lexer(this.states, this.state);
      };
      Lexer.prototype.has = function(tokenType) {
        return true;
      };
      return {
        compile,
        states: compileStates,
        error: Object.freeze({ error: true }),
        fallback: Object.freeze({ fallback: true }),
        keywords: keywordTransform
      };
    });
  }
});

// node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/lexer.js
var require_lexer = __commonJS({
  "node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/lexer.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.lexer = exports.states = void 0;
    var moo_1 = __importDefault(require_moo());
    exports.states = {
      body: {
        doubleapos: { match: "''", value: () => "'" },
        quoted: {
          lineBreaks: true,
          match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
          value: (src) => src.slice(1, -1).replace(/''/g, "'")
        },
        argument: {
          lineBreaks: true,
          match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
          push: "arg",
          value: (src) => src.substring(1).trim()
        },
        octothorpe: "#",
        end: { match: "}", pop: 1 },
        content: { lineBreaks: true, match: /[^][^{}#']*/u }
      },
      arg: {
        select: {
          lineBreaks: true,
          match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
          next: "select",
          value: (src) => src.split(",")[1].trim()
        },
        "func-args": {
          lineBreaks: true,
          match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
          next: "body",
          value: (src) => src.split(",")[1].trim()
        },
        "func-simple": {
          lineBreaks: true,
          match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
          value: (src) => src.substring(1).trim()
        },
        end: { match: "}", pop: 1 }
      },
      select: {
        offset: {
          lineBreaks: true,
          match: /\s*offset\s*:\s*\d+\s*/u,
          value: (src) => src.split(":")[1].trim()
        },
        case: {
          lineBreaks: true,
          match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
          push: "body",
          value: (src) => src.substring(0, src.indexOf("{")).trim()
        },
        end: { match: /\s*\}/u, pop: 1 }
      }
    };
    exports.lexer = moo_1.default.states(exports.states);
  }
});

// node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/parser.js
var require_parser = __commonJS({
  "node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/parser.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parse = exports.ParseError = void 0;
    var lexer_js_1 = require_lexer();
    var getContext = (lt) => ({
      offset: lt.offset,
      line: lt.line,
      col: lt.col,
      text: lt.text,
      lineBreaks: lt.lineBreaks
    });
    var isSelectType = (type) => type === "plural" || type === "select" || type === "selectordinal";
    function strictArgStyleParam(lt, param) {
      let value = "";
      let text = "";
      for (const p3 of param) {
        const pText = p3.ctx.text;
        text += pText;
        switch (p3.type) {
          case "content":
            value += p3.value;
            break;
          case "argument":
          case "function":
          case "octothorpe":
            value += pText;
            break;
          default:
            throw new ParseError(lt, `Unsupported part in strict mode function arg style: ${pText}`);
        }
      }
      const c3 = {
        type: "content",
        value: value.trim(),
        ctx: Object.assign({}, param[0].ctx, { text })
      };
      return [c3];
    }
    var strictArgTypes = [
      "number",
      "date",
      "time",
      "spellout",
      "ordinal",
      "duration"
    ];
    var defaultPluralKeys = ["zero", "one", "two", "few", "many", "other"];
    var ParseError = class extends Error {
      /** @internal */
      constructor(lt, msg) {
        super(lexer_js_1.lexer.formatError(lt, msg));
      }
    };
    exports.ParseError = ParseError;
    var Parser = class {
      constructor(src, opt) {
        var _a, _b, _c, _d;
        this.lexer = lexer_js_1.lexer.reset(src);
        this.cardinalKeys = (_a = opt === null || opt === void 0 ? void 0 : opt.cardinal) !== null && _a !== void 0 ? _a : defaultPluralKeys;
        this.ordinalKeys = (_b = opt === null || opt === void 0 ? void 0 : opt.ordinal) !== null && _b !== void 0 ? _b : defaultPluralKeys;
        this.strict = (_c = opt === null || opt === void 0 ? void 0 : opt.strict) !== null && _c !== void 0 ? _c : false;
        this.strictPluralKeys = (_d = opt === null || opt === void 0 ? void 0 : opt.strictPluralKeys) !== null && _d !== void 0 ? _d : true;
      }
      parse() {
        return this.parseBody(false, true);
      }
      checkSelectKey(lt, type, key) {
        if (key[0] === "=") {
          if (type === "select")
            throw new ParseError(lt, `The case ${key} is not valid with select`);
        } else if (type !== "select") {
          const keys2 = type === "plural" ? this.cardinalKeys : this.ordinalKeys;
          if (this.strictPluralKeys && keys2.length > 0 && !keys2.includes(key)) {
            const msg = `The ${type} case ${key} is not valid in this locale`;
            throw new ParseError(lt, msg);
          }
        }
      }
      parseSelect({ value: arg }, inPlural, ctx, type) {
        const sel = { type, arg, cases: [], ctx };
        if (type === "plural" || type === "selectordinal")
          inPlural = true;
        else if (this.strict)
          inPlural = false;
        for (const lt of this.lexer) {
          switch (lt.type) {
            case "offset":
              if (type === "select")
                throw new ParseError(lt, "Unexpected plural offset for select");
              if (sel.cases.length > 0)
                throw new ParseError(lt, "Plural offset must be set before cases");
              sel.pluralOffset = Number(lt.value);
              ctx.text += lt.text;
              ctx.lineBreaks += lt.lineBreaks;
              break;
            case "case": {
              this.checkSelectKey(lt, type, lt.value);
              sel.cases.push({
                key: lt.value,
                tokens: this.parseBody(inPlural),
                ctx: getContext(lt)
              });
              break;
            }
            case "end":
              return sel;
            default:
              throw new ParseError(lt, `Unexpected lexer token: ${lt.type}`);
          }
        }
        throw new ParseError(null, "Unexpected message end");
      }
      parseArgToken(lt, inPlural) {
        const ctx = getContext(lt);
        const argType = this.lexer.next();
        if (!argType)
          throw new ParseError(null, "Unexpected message end");
        ctx.text += argType.text;
        ctx.lineBreaks += argType.lineBreaks;
        if (this.strict && (argType.type === "func-simple" || argType.type === "func-args") && !strictArgTypes.includes(argType.value)) {
          const msg = `Invalid strict mode function arg type: ${argType.value}`;
          throw new ParseError(lt, msg);
        }
        switch (argType.type) {
          case "end":
            return { type: "argument", arg: lt.value, ctx };
          case "func-simple": {
            const end = this.lexer.next();
            if (!end)
              throw new ParseError(null, "Unexpected message end");
            if (end.type !== "end")
              throw new ParseError(end, `Unexpected lexer token: ${end.type}`);
            ctx.text += end.text;
            if (isSelectType(argType.value.toLowerCase()))
              throw new ParseError(argType, `Invalid type identifier: ${argType.value}`);
            return {
              type: "function",
              arg: lt.value,
              key: argType.value,
              ctx
            };
          }
          case "func-args": {
            if (isSelectType(argType.value.toLowerCase())) {
              const msg = `Invalid type identifier: ${argType.value}`;
              throw new ParseError(argType, msg);
            }
            let param = this.parseBody(this.strict ? false : inPlural);
            if (this.strict && param.length > 0)
              param = strictArgStyleParam(lt, param);
            return {
              type: "function",
              arg: lt.value,
              key: argType.value,
              param,
              ctx
            };
          }
          case "select":
            if (isSelectType(argType.value))
              return this.parseSelect(lt, inPlural, ctx, argType.value);
            else
              throw new ParseError(argType, `Unexpected select type ${argType.value}`);
          default:
            throw new ParseError(argType, `Unexpected lexer token: ${argType.type}`);
        }
      }
      parseBody(inPlural, atRoot) {
        const tokens = [];
        let content = null;
        for (const lt of this.lexer) {
          if (lt.type === "argument") {
            if (content)
              content = null;
            tokens.push(this.parseArgToken(lt, inPlural));
          } else if (lt.type === "octothorpe" && inPlural) {
            if (content)
              content = null;
            tokens.push({ type: "octothorpe", ctx: getContext(lt) });
          } else if (lt.type === "end" && !atRoot) {
            return tokens;
          } else {
            let value = lt.value;
            if (!inPlural && lt.type === "quoted" && value[0] === "#") {
              if (value.includes("{")) {
                const errMsg = `Unsupported escape pattern: ${value}`;
                throw new ParseError(lt, errMsg);
              }
              value = lt.text;
            }
            if (content) {
              content.value += value;
              content.ctx.text += lt.text;
              content.ctx.lineBreaks += lt.lineBreaks;
            } else {
              content = { type: "content", value, ctx: getContext(lt) };
              tokens.push(content);
            }
          }
        }
        if (atRoot)
          return tokens;
        throw new ParseError(null, "Unexpected message end");
      }
    };
    function parse2(src, options = {}) {
      const parser = new Parser(src, options);
      return parser.parse();
    }
    exports.parse = parse2;
  }
});

// packages/affix/index.js
import { html as html3 } from "lit";
import WarpElement from "@warp-ds/elements-core";
import { ifDefined } from "lit/directives/if-defined.js";

// node_modules/.pnpm/@warp-ds+css@1.9.1/node_modules/@warp-ds/css/component-classes/index.js
var badge = {
  base: "py-4 px-8 border-0 rounded-4 text-xs inline-flex",
  neutral: "bg-[--w-color-badge-neutral-background] s-text",
  info: "bg-[--w-color-badge-info-background] s-text",
  positive: "bg-[--w-color-badge-positive-background] s-text",
  warning: "bg-[--w-color-badge-warning-background] s-text",
  negative: "bg-[--w-color-badge-negative-background] s-text",
  disabled: "s-bg-disabled s-text",
  price: "bg-[--w-black/70] s-text-inverted-static",
  sponsored: "bg-[--w-color-badge-sponsored-background] s-text",
  // Notification badge is deprecated: Do not use! TODO: Remove in v2
  notification: "i-bg-$color-badge-notification-background i-text-$color-badge-notification-text",
  positionBase: "absolute backdrop-blur",
  positionTL: "rounded-tl-0 rounded-tr-0 rounded-bl-0 top-0 left-0",
  positionTR: "rounded-tl-0 rounded-tr-0 rounded-br-0 top-0 right-0",
  positionBR: "rounded-tr-0 rounded-br-0 rounded-bl-0 bottom-0 right-0",
  positionBL: "rounded-tl-0 rounded-br-0 rounded-bl-0 bottom-0 left-0"
};
var box = {
  box: "group block relative break-words last-child:mb-0 p-16 rounded-8",
  // Relative here enables w-clickable
  bleed: "-mx-16 sm:mx-0 rounded-l-0 rounded-r-0 sm:rounded-8",
  // We target L and R to override the default rounded-8
  info: "s-bg-info-subtle",
  neutral: "bg-[--w-s-color-surface-sunken]",
  bordered: "border-2 s-border s-bg",
  infoClickable: "hover:s-bg-info-subtle-hover active:s-bg-info-subtle-hover",
  neutralClickable: "hover:s-bg-subtle-hover active:s-bg-subtle-hover",
  borderedClickable: "hover:s-bg-hover active:s-bg-hover hover:s-border-hover active:s-border-hover"
};
var pill = {
  pill: "flex items-center",
  button: "inline-flex items-center focusable text-xs transition-all",
  suggestion: "bg-[--w-color-pill-suggestion-background] hover:bg-[--w-color-pill-suggestion-background-hover] active:bg-[--w-color-pill-suggestion-background-active] s-text font-bold",
  filter: "s-bg-primary hover:s-bg-primary-hover active:s-bg-primary-active s-text-inverted",
  label: "pl-12 py-8 rounded-l-full",
  labelWithoutClose: "pr-12 rounded-r-full",
  labelWithClose: "pr-2",
  close: "pr-12 pl-4 py-8 rounded-r-full",
  a11y: "sr-only"
};
var card = {
  card: "cursor-pointer overflow-hidden relative transition-all",
  cardShadow: "rounded-8 shadow-s hover:shadow-m hover:s-bg-subtle-hover tap-highlight-transparent",
  cardFlat: "border-2 rounded-4",
  cardFlatUnselected: "s-bg s-border hover:s-bg-hover hover:s-border-hover active:s-bg-active active:s-border-active",
  cardFlatSelected: "s-border-selected s-bg-selected hover:s-bg-selected-hover hover:s-border-selected-hover active:s-border-selected-active active:s-bg-selected-active",
  cardUnselected: "s-bg",
  cardSelected: "s-border-selected s-bg-selected hover:s-border-selected-hover hover:s-bg-selected-hover active:s-border-selected-active active:s-bg-selected-active",
  cardOutline: "active:s-border absolute rounded-8 inset-0 transition-all border-2",
  cardOutlineUnselected: "border-transparent",
  cardOutlineSelected: "s-border-selected hover:s-border-selected-hover",
  a11y: "sr-only"
};
var toaster = {
  container: "fixed transform translate-z-0 bottom-16 left-0 right-0 mx-8 sm:mx-16 z-50 pointer-events-none",
  content: "w-full",
  toaster: "grid auto-rows-auto justify-items-center justify-center mx-auto pointer-events-none"
};
var toast = {
  wrapper: "relative overflow-hidden w-full",
  toast: "flex group p-8 mt-16 rounded-8 border-2 w-full pointer-events-auto transition-all",
  positive: "s-bg-positive-subtle s-border-positive-subtle s-text",
  warning: "s-bg-warning-subtle s-border-warning-subtle s-text",
  negative: "s-bg-negative-subtle s-border-negative-subtle s-text",
  icon: "shrink-0 rounded-full w-[16px] h-[16px] m-[8px]",
  iconPositive: "s-icon-positive",
  iconWarning: "s-icon-warning",
  iconNegative: "s-icon-negative",
  iconLoading: "animate-bounce",
  content: "self-center mr-8 py-4 last-child:mb-0",
  close: "bg-transparent ml-auto p-[8px] s-icon hover:s-icon-hover active:s-icon-active"
};
var buttonReset = "focus:outline-none appearance-none cursor-pointer bg-transparent border-0 m-0 p-0 inline-block";
var expandable = {
  expandable: "will-change-height",
  expandableTitle: "font-bold s-text",
  expandableBox: "s-bg-subtle hover:s-bg-subtle-hover py-0 px-0 " + box.box,
  expandableInfo: "s-bg-info-subtle! hover:s-bg-info-subtle-hover!",
  expandableBleed: box.bleed,
  chevron: "inline-block align-middle s-icon",
  chevronNonBox: "ml-8",
  chevronBox: "",
  chevronTransform: "transform transition-transform transform-gpu ease-in-out",
  chevronExpand: "-rotate-180",
  chevronCollapse: "rotate-180",
  elementsTransformChevronDownPart: "part-[w-icon-chevron-down-16-part]:transform part-[w-icon-chevron-down-16-part]:transition-transform part-[w-icon-chevron-down-16-part]:transform-gpu part-[w-icon-chevron-down-16-part]:ease-in-out",
  elementsChevronDownExpandPart: "part-[w-icon-chevron-down-16-part]:-rotate-180",
  elementsTransformChevronUpPart: "part-[w-icon-chevron-up-16-part]:transform part-[w-icon-chevron-up-16-part]:transition-transform part-[w-icon-chevron-up-16-part]:transform-gpu part-[w-icon-chevron-up-16-part]:ease-in-out",
  elementsChevronUpCollapsePart: "part-[w-icon-chevron-up-16-part]:rotate-180",
  expansion: "overflow-hidden",
  expansionNotExpanded: "h-0 invisible",
  button: buttonReset + " hover:underline focus-visible:underline",
  buttonBox: "w-full text-left relative inline-flex items-center justify-between " + box.box,
  paddingTop: "pt-0",
  title: "flex w-full justify-between items-center",
  titleType: "h4"
};
var buttonDefaultStyling = "font-bold focusable justify-center transition-colors ease-in-out";
var buttonColors = {
  primary: "s-text-inverted bg-[--w-color-button-primary-background] hover:bg-[--w-color-button-primary-background-hover] active:bg-[--w-color-button-primary-background-active]",
  secondary: "s-text-link s-border s-bg hover:s-bg-hover hover:s-border-hover active:s-bg-active",
  utility: "s-text s-bg hover:s-bg-hover active:s-bg-active s-border hover:s-border-hover active:s-border-active",
  destructive: "s-bg-negative s-text-inverted hover:s-bg-negative-hover active:s-bg-negative-active",
  pill: "s-icon hover:s-icon-hover active:s-icon-active bg-transparent hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]",
  disabled: "s-text-inverted s-bg-disabled",
  quiet: "bg-transparent s-text-link hover:s-bg-hover active:s-bg-active",
  utilityQuiet: "s-text bg-transparent hover:s-bg-hover active:s-bg-active",
  negativeQuiet: "bg-transparent s-text-negative hover:s-bg-negative-subtle-hover active:s-bg-negative-subtle-active",
  loading: "s-text s-bg-subtle",
  link: "s-text-link"
};
var buttonTypes = {
  primary: `border-0 rounded-8 ${buttonDefaultStyling}`,
  secondary: `border-2 rounded-8 ${buttonDefaultStyling}`,
  utility: `border rounded-4 ${buttonDefaultStyling}`,
  negative: `border-0 rounded-8 ${buttonDefaultStyling}`,
  pill: `p-4 rounded-full border-0 inline-flex items-center justify-center hover:bg-clip-padding ${buttonDefaultStyling}`,
  link: `bg-transparent focusable ease-in-out inline active:underline hover:underline ${buttonColors.link}`
};
var buttonSizes = {
  xsmall: "py-6 px-16",
  small: "py-8 px-16",
  medium: "py-10 px-14",
  large: "py-12 px-16",
  utility: "py-[11px] px-[15px]",
  smallUtility: "py-[7px] px-[15px]",
  pill: "min-h-[44px] min-w-[44px]",
  pillSmall: "min-h-32 min-w-32",
  link: "p-0"
};
var buttonTextSizes = {
  medium: "text-m leading-[24]",
  xsmall: "text-xs"
};
var buttonVariants = {
  inProgress: `border-transparent animate-inprogress pointer-events-none ${buttonColors.loading}`,
  // .button--in-progress, a.button--in-progress:visited
  quiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  utilityQuiet: `border-0 rounded-4 ${buttonDefaultStyling}`,
  negativeQuiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  isDisabled: `font-bold justify-center transition-colors ease-in-out cursor-default pointer-events-none ${buttonColors.disabled}`
  // .button:disabled, .button--is-disabled
};
var button = {
  // Buttontypes
  secondary: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  // .button--secondary, .button--default, .button
  secondaryHref: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondaryDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondarySmall: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondarySmallDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondaryQuiet: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondaryQuietDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondarySmallQuiet: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondarySmallQuietDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondaryLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall}  ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallQuietLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  secondaryQuietLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  primary: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.primary} ${buttonColors.primary}`,
  // .button--primary, .button--cta
  primaryDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.isDisabled} ${buttonTypes.primary}`,
  primarySmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.primary} ${buttonColors.primary}`,
  primarySmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.isDisabled} ${buttonTypes.primary} `,
  primaryQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primaryQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primarySmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primarySmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primaryLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall}  ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primaryQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  utility: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonColors.utility}`,
  // .button--utility
  utilityDisabled: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilityQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  // .button--utility-flat
  utilityQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilitySmall: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonColors.utility}`,
  utilitySmallDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilitySmallQuiet: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  utilitySmallQuietDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilityLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilitySmallLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilityQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  utilitySmallQuietLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  negative: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonColors.destructive}`,
  // .button--destructive
  negativeDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  // .button--destructive-flat
  negativeQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet}${buttonVariants.isDisabled}`,
  negativeSmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonColors.destructive}`,
  negativeSmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeSmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  negativeSmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.isDisabled}`,
  negativeLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonTypes.negative}`,
  negativeQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.inProgress}`,
  pill: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill}`,
  // .button--pill
  pillSmall: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonColors.pill}`,
  pillLoading: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  pillSmallLoading: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  link: `${buttonSizes.link} ${buttonTextSizes.medium} ${buttonTypes.link}`,
  linkSmall: `${buttonSizes.link} ${buttonTextSizes.xsmall} ${buttonTypes.link}`,
  linkAsButton: "inline-block hover:no-underline text-center",
  a11y: "sr-only",
  fullWidth: "w-full max-w-full",
  contentWidth: "max-w-max"
};
var modal = {
  transparentBg: "",
  //TODO: Remove in v2 - previously used for opacity before changing to a rgba background in backdrop
  backdrop: "fixed inset-0 flex sm:place-content-center sm:place-items-center items-end z-30 [--w-modal-max-height:80%] [--w-modal-width:640px] bg-[--w-black/25]",
  modal: "pb-safe-[32] shadow-m max-h-[--w-modal-max-height] min-h-[--w-modal-min-height] w-[--w-modal-width] h-[--w-modal-height] relative transition-300 ease-in-out backface-hidden will-change-height rounded-8 mx-0 sm:mx-16 bg-[--w-s-color-surface-elevated-100] flex flex-col overflow-hidden outline-none space-y-16 pt-8 sm:pt-32 sm:pb-32 rounded-b-0 sm:rounded-b-8",
  content: "block overflow-y-auto overflow-x-hidden last-child:mb-0 grow shrink px-16 sm:px-32 relative",
  footer: "flex justify-end shrink-0 px-16 sm:px-32",
  transitionTitle: "transition-all duration-300",
  transitionTitleCenter: "justify-self-center self-center",
  transitionTitleColSpan: "col-span-2",
  title: "py-8 sm:py-0 -mt-4 sm:-mt-8 min-h-40 sm:min-h-48 grid gap-8 sm:gap-16 grid-cols-[auto_1fr_auto] items-start px-16 sm:px-32 border-b sm:border-b-0 shrink-0",
  titleText: "mb-0 h4 sm:h3",
  titleButton: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} sm:min-h-[44px] sm:min-w-[44px] min-h-[32px] min-w-[32px]`,
  titleButtonLeft: "-ml-8 sm:-ml-12 justify-self-start",
  titleButtonRight: "-mr-8 sm:-mr-12 justify-self-end",
  titleButtonIcon: "h-16 w-16 sm:h-24 sm:w-24",
  titleButtonIconRotated: "transform rotate-90"
};
var alert = {
  alert: "flex p-16 border border-l-4 rounded-4 s-text",
  willChangeHeight: "will-change-height",
  textWrapper: "last-child:mb-0 text-s",
  title: "text-s",
  icon: "w-16 mr-8 min-w-16",
  negative: "s-border-negative-subtle s-border-l-negative s-bg-negative-subtle",
  negativeIcon: "s-icon-negative",
  positive: "s-border-positive-subtle s-border-l-positive s-bg-positive-subtle",
  positiveIcon: "s-icon-positive",
  warning: "s-border-warning-subtle s-border-l-warning s-bg-warning-subtle",
  warningIcon: "s-icon-warning",
  info: "s-border-info-subtle s-border-l-info s-bg-info-subtle",
  infoIcon: "s-icon-info"
};
var input = {
  default: "block text-m mb-0 leading-m s-text s-bg s-border hover:s-border-hover active:s-border-selected rounded-4 py-12 px-8 block border-1 w-full focusable focus:[--w-outline-offset:-2px] caret-current",
  textArea: "min-h-[42] sm:min-h-[45]",
  disabled: "s-bg-disabled-subtle s-border-disabled hover:s-border-disabled! s-text-disabled pointer-events-none",
  invalid: "s-border-negative s-text-negative! hover:s-border-negative-hover! outline-[--w-s-color-border-negative]!",
  readOnly: "pl-0 bg-transparent! border-0! pointer-events-none",
  placeholder: "placeholder:s-text-placeholder",
  wrapper: "relative",
  suffix: "pr-40",
  prefix: "pl-40"
};
var select = {
  default: "block text-m mb-0 leading-m s-text s-bg s-border hover:s-border-hover active:s-border-active rounded-4 py-12 px-8 block border-1 w-full focusable focus:[--w-outline-offset:-2px] appearance-none pr-32 cursor-pointer caret-current",
  disabled: "s-bg-disabled-subtle s-border-disabled hover:s-border-disabled! active:s-border-disabled! s-text-disabled pointer-events-none",
  invalid: "s-border-negative hover:s-border-negative-hover! outline-[--w-s-color-border-negative]!",
  readOnly: "pl-0 bg-transparent border-0 pointer-events-none before:hidden",
  wrapper: "relative",
  selectWrapper: `relative before:block before:absolute before:right-0 before:bottom-0 before:w-32 before:h-full before:pointer-events-none `,
  chevron: "absolute top-[30%] block right-0 bottom-0 w-32 h-full s-icon pointer-events-none cursor-pointer",
  chevronDisabled: "opacity-25"
};
var label = {
  label: "antialiased block relative text-s font-bold pb-4 cursor-pointer s-text",
  optional: "pl-8 font-normal text-s s-text-subtle",
  labelInvalid: "s-text-negative"
  // TODO: Remove in v2 - kept for backwards compatibility
};
var helpText = {
  helpText: "text-xs mt-4 block",
  helpTextColor: "s-text-subtle",
  helpTextColorInvalid: "s-text-negative",
  // TODO: Remove below properties in v2 - kept for backwards compatibility
  helpTextValid: "s-text-positive",
  helpTextInvalid: "s-text-negative"
};
var prefixSuffixWrapperBase = "absolute top-0 bottom-0 flex justify-center items-center focusable rounded-4 focus:[--w-outline-offset:-2px] bg-transparent ";
var suffix = {
  wrapper: prefixSuffixWrapperBase + "right-0",
  wrapperWithLabel: "w-max pr-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var prefix = {
  wrapper: prefixSuffixWrapperBase + "left-0",
  wrapperWithLabel: "w-max pl-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var breadcrumbs = {
  wrapper: "flex space-x-8",
  text: "s-text",
  link: "s-text-link",
  separator: "select-none s-icon",
  a11y: "sr-only"
};
var toggle = {
  // wrapper classes
  field: "relative text-m",
  // true
  wrapper: "relative py-1",
  // true
  wrapperRadioButtons: "inline-flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && !isEqualWidth
  wrapperRadioButtonsJustified: "flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && isEqualWidth,
  // group classes
  radioButtonsGroup: "group",
  // isRadioButton
  radioButtonsGroupJustified: "grow-1 shrink-0 basis-auto",
  // isRadioButton && isEqualWidth
  // input classes
  input: "peer",
  a11y: "sr-only",
  // label classes
  label: "peer-focus:focusable cursor-pointer text-m s-text s-border py-2 pl-28 select-none relative block before:border before:absolute before:transition-all before:left-0 before:w-20 before:h-20 before:top-2",
  // !isRadioButton
  labelBefore: 'before:content-[""] before:block',
  // !isRadioButton && !isIndeterminate
  checkbox: "before:s-bg before:rounded-2 hover:before:s-border-primary hover:before:s-bg-hover peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-primary peer-checked:before:s-bg-primary peer-checked:peer-hover:before:s-border-primary-hover peer-checked:peer-hover:before:s-bg-primary-hover",
  // isCheckbox && !isIndeterminate && !isInvalid && !isDisabled
  checkboxInvalid: "before:s-bg before:s-border-negative before:rounded-2 hover:before:s-bg-negative-subtle-hover hover:before:s-border-negative-hover peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-bg-negative peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-bg-negative-hover peer-checked:peer-hover:before:s-border-negative-hover",
  // isCheckbox && !isIndeterminate && isInvalid && !isDisabled
  checkboxDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-2 peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-disabled peer-checked:before:s-bg-disabled",
  // isCheckbox && !isIndeterminate && !isInvalid && isDisabled
  indeterminate: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-primary peer-indeterminate:before:s-bg-primary peer-indeterminate:hover:before:s-border-primary-hover peer-indeterminate:hover:before:s-bg-primary-hover',
  // isCheckbox && isIndeterminate && !isInvalid && !isDisabled
  indeterminateInvalid: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-negative peer-indeterminate:before:s-bg-negative peer-indeterminate:hover:before:s-border-negative-hover peer-indeterminate:hover:before:s-bg-negative-hover',
  // isCheckbox && isIndeterminate && isInvalid && !isDisabled
  indeterminateDisabled: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold pointer-events-none before:s-icon-inverted peer-indeterminate:before:s-border-disabled peer-indeterminate:before:s-bg-disabled',
  // isCheckbox && isIndeterminate && !isInvalid && isDisabled
  radio: "before:s-bg before:rounded-full peer-checked:before:border-[6] peer-checked:before:s-border-selected peer-checked:peer-hover:before:s-border-selected-hover peer-hover:before:s-border-primary peer-hover:before:s-bg-hover",
  // isRadio && !isDisabled && !isInvalid
  radioInvalid: "before:s-bg before:s-border-negative before:rounded-full peer-checked:before:border-[6] peer-hover:before:s-bg-negative-subtle peer-hover:before:s-border-negative-hover peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-border-negative-hover",
  // isRadio && isInvalid && !isDisabled
  radioDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-full peer-checked:before:border-[6]",
  // isRadio && !isInvalid && isDisabled
  radioButtonsLabel: "peer-hover:peer-not-checked:s-bg-hover peer-checked:s-text-inverted peer-checked:s-bg-primary peer-checked:s-border-primary block relative font-bold cursor-pointer s-text-link text-center s-bg border-2 s-border group-first-of-type:rounded-tl-8 group-first-of-type:rounded-bl-8 group-last-of-type:rounded-tr-8 group-last-of-type:rounded-br-8 group-not-last-of-type:border-r-0 peer-checked:z-10 group-not-first:-ml-2",
  // isRadioButtons
  radioButtonsRegular: "text-s py-8 pl-12 pr-14",
  // isRadioButtons && !isSmall
  radioButtonsSmall: "text-xs py-[5px] px-[8px]"
  // isRadioButtons && isSmall
};
var deadToggle = {
  wrapper: `${toggle.wrapper} h-20 w-20 pointer-events-none`,
  input: `${toggle.input} hidden`,
  inputVue: "hidden",
  labelRadio: `${toggle.label} ${toggle.labelBefore} ${toggle.radio}`,
  labelCheckbox: `${toggle.label} ${toggle.labelBefore} ${toggle.checkbox}`,
  labelVue: "-mt-2"
};
var clickable = {
  toggle: "absolute inset-0 h-full w-full appearance-none cursor-pointer focusable focusable-inset",
  label: `px-12 ${label.label} py-8! cursor-pointer focusable focusable-inset`,
  buttonOrLink: "bg-transparent focusable",
  buttonOrLinkStretch: "inset-0 absolute"
};
var attention = {
  base: "border-2 relative flex items-start",
  tooltip: "s-bg-inverted border-[--w-s-color-background-inverted] shadow-m s-text-inverted-static rounded-4 py-6 px-8",
  callout: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8",
  highlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8 drop-shadow-m translate-z-0",
  popover: "bg-[--w-s-color-surface-elevated-300] border-[--w-s-color-surface-elevated-300] s-text rounded-8 p-16 drop-shadow-m translate-z-0",
  arrowBase: "absolute h-[14px] w-[14px] border-2 border-b-0 border-r-0 rounded-tl-4 transform",
  arrowDirectionLeftStart: "-left-[8px]",
  arrowDirectionLeft: "-left-[8px]",
  arrowDirectionLeftEnd: "-left-[8px]",
  arrowDirectionRightStart: "-right-[8px]",
  arrowDirectionRight: "-right-[8px]",
  arrowDirectionRightEnd: "-right-[8px]",
  arrowDirectionBottomStart: "-bottom-[8px]",
  arrowDirectionBottom: "-bottom-[8px]",
  arrowDirectionBottomEnd: "-bottom-[8px]",
  arrowDirectionTopStart: "-top-[8px]",
  arrowDirectionTop: "-top-[8px]",
  arrowDirectionTopEnd: "-top-[8px]",
  arrowTooltip: "s-bg-inverted border-[--w-s-color-background-inverted]",
  arrowCallout: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  arrowPopover: "bg-[--w-s-color-surface-elevated-300] border-[--w-s-color-surface-elevated-300]",
  arrowHighlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  content: "last-child:mb-0",
  notCallout: "absolute z-50",
  closeBtn: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} justify-self-end -mr-8 ml-8`
};

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/search-16.js
import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";

// node_modules/.pnpm/@lingui+core@4.7.1/node_modules/@lingui/core/dist/index.mjs
var import_unraw = __toESM(require_dist(), 1);

// node_modules/.pnpm/@lingui+message-utils@4.7.1/node_modules/@lingui/message-utils/dist/compileMessage.mjs
var import_parser = __toESM(require_parser(), 1);
function processTokens(tokens, mapText) {
  if (!tokens.filter((token) => token.type !== "content").length) {
    return tokens.map((token) => mapText(token.value)).join("");
  }
  return tokens.map((token) => {
    var _a;
    if (token.type === "content") {
      return mapText(token.value);
    } else if (token.type === "octothorpe") {
      return "#";
    } else if (token.type === "argument") {
      return [token.arg];
    } else if (token.type === "function") {
      const _param = (_a = token == null ? void 0 : token.param) == null ? void 0 : _a[0];
      if (_param) {
        return [token.arg, token.key, _param.value.trim()];
      } else {
        return [token.arg, token.key];
      }
    }
    const offset = token.pluralOffset;
    const formatProps = {};
    token.cases.forEach((item) => {
      formatProps[item.key.replace(/^=(.)+/, "$1")] = processTokens(
        item.tokens,
        mapText
      );
    });
    return [
      token.arg,
      token.type,
      __spreadValues({
        offset
      }, formatProps)
    ];
  });
}
function compileMessage(message, mapText = (v3) => v3) {
  try {
    return processTokens((0, import_parser.parse)(message), mapText);
  } catch (e2) {
    console.error(`${e2.message} 

Message: ${message}`);
    return message;
  }
}

// node_modules/.pnpm/@lingui+core@4.7.1/node_modules/@lingui/core/dist/index.mjs
var isString = (s3) => typeof s3 === "string";
var isFunction = (f3) => typeof f3 === "function";
var cache = /* @__PURE__ */ new Map();
var defaultLocale = "en";
function normalizeLocales(locales) {
  const out = Array.isArray(locales) ? locales : [locales];
  return [...out, defaultLocale];
}
function date(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("date", _locales, format),
    () => new Intl.DateTimeFormat(_locales, format)
  );
  return formatter.format(isString(value) ? new Date(value) : value);
}
function number(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("number", _locales, format),
    () => new Intl.NumberFormat(_locales, format)
  );
  return formatter.format(value);
}
function plural(locales, ordinal, value, _a) {
  var _b = _a, { offset = 0 } = _b, rules = __objRest(_b, ["offset"]);
  var _a2, _b2;
  const _locales = normalizeLocales(locales);
  const plurals = ordinal ? getMemoized(
    () => cacheKey("plural-ordinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "ordinal" })
  ) : getMemoized(
    () => cacheKey("plural-cardinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "cardinal" })
  );
  return (_b2 = (_a2 = rules[value]) != null ? _a2 : rules[plurals.select(value - offset)]) != null ? _b2 : rules.other;
}
function getMemoized(getKey, construct) {
  const key = getKey();
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales, options) {
  const localeKey = locales.join("-");
  return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
var UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
var OCTOTHORPE_PH = "%__lingui_octothorpe__%";
var getDefaultFormats = (locale, passedLocales, formats = {}) => {
  const locales = passedLocales || locale;
  const style = (format) => {
    return typeof format === "object" ? format : formats[format] || { style: format };
  };
  const replaceOctothorpe = (value, message) => {
    const numberFormat = Object.keys(formats).length ? style("number") : void 0;
    const valueStr = number(locales, value, numberFormat);
    return message.replace(new RegExp(OCTOTHORPE_PH, "g"), valueStr);
  };
  return {
    plural: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, false, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    selectordinal: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, true, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    select: selectFormatter,
    number: (value, format) => number(locales, value, style(format)),
    date: (value, format) => date(locales, value, style(format))
  };
};
var selectFormatter = (value, rules) => {
  var _a;
  return (_a = rules[value]) != null ? _a : rules.other;
};
function interpolate(translation, locale, locales) {
  return (values = {}, formats) => {
    const formatters = getDefaultFormats(locale, locales, formats);
    const formatMessage = (tokens) => {
      if (!Array.isArray(tokens))
        return tokens;
      return tokens.reduce((message, token) => {
        if (token === "#") {
          return message + OCTOTHORPE_PH;
        }
        if (isString(token)) {
          return message + token;
        }
        const [name, type, format] = token;
        let interpolatedFormat = {};
        if (type === "plural" || type === "selectordinal" || type === "select") {
          Object.entries(format).forEach(
            ([key, value2]) => {
              interpolatedFormat[key] = formatMessage(value2);
            }
          );
        } else {
          interpolatedFormat = format;
        }
        let value;
        if (type) {
          const formatter = formatters[type];
          value = formatter(values[name], interpolatedFormat);
        } else {
          value = values[name];
        }
        if (value == null) {
          return message;
        }
        return message + value;
      }, "");
    };
    const result = formatMessage(translation);
    if (isString(result) && UNICODE_REGEX.test(result)) {
      return (0, import_unraw.unraw)(result.trim());
    }
    if (isString(result))
      return result.trim();
    return result ? String(result) : "";
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var EventEmitter = class {
  constructor() {
    __publicField$1(this, "_events", {});
  }
  on(event, listener) {
    var _a2;
    var _a;
    (_a2 = (_a = this._events)[event]) != null ? _a2 : _a[event] = [];
    this._events[event].push(listener);
    return () => this.removeListener(event, listener);
  }
  removeListener(event, listener) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    const index = maybeListeners.indexOf(listener);
    if (~index)
      maybeListeners.splice(index, 1);
  }
  emit(event, ...args) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    maybeListeners.map((listener) => listener.apply(this, args));
  }
  _getListeners(event) {
    const maybeListeners = this._events[event];
    return Array.isArray(maybeListeners) ? maybeListeners : false;
  }
};
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField2 = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var I18n = class extends EventEmitter {
  constructor(params) {
    var _a;
    super();
    __publicField2(this, "_locale", "");
    __publicField2(this, "_locales");
    __publicField2(this, "_localeData", {});
    __publicField2(this, "_messages", {});
    __publicField2(this, "_missing");
    __publicField2(this, "t", this._.bind(this));
    if (params.missing != null)
      this._missing = params.missing;
    if (params.messages != null)
      this.load(params.messages);
    if (params.localeData != null)
      this.loadLocaleData(params.localeData);
    if (typeof params.locale === "string" || params.locales) {
      this.activate((_a = params.locale) != null ? _a : defaultLocale, params.locales);
    }
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    var _a;
    return (_a = this._messages[this._locale]) != null ? _a : {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    var _a;
    return (_a = this._localeData[this._locale]) != null ? _a : {};
  }
  _loadLocaleData(locale, localeData) {
    const maybeLocaleData = this._localeData[locale];
    if (!maybeLocaleData) {
      this._localeData[locale] = localeData;
    } else {
      Object.assign(maybeLocaleData, localeData);
    }
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(localeOrAllData, localeData) {
    if (localeData != null) {
      this._loadLocaleData(localeOrAllData, localeData);
    } else {
      Object.keys(localeOrAllData).forEach(
        (locale) => this._loadLocaleData(locale, localeOrAllData[locale])
      );
    }
    this.emit("change");
  }
  _load(locale, messages43) {
    const maybeMessages = this._messages[locale];
    if (!maybeMessages) {
      this._messages[locale] = messages43;
    } else {
      Object.assign(maybeMessages, messages43);
    }
  }
  load(localeOrMessages, messages43) {
    if (typeof localeOrMessages == "string" && typeof messages43 === "object") {
      this._load(localeOrMessages, messages43);
    } else {
      Object.entries(localeOrMessages).forEach(
        ([locale, messages210]) => this._load(locale, messages210)
      );
    }
    this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale, locales, messages: messages43 }) {
    this._locale = locale;
    this._locales = locales || void 0;
    this._messages[this._locale] = messages43;
    this.emit("change");
  }
  activate(locale, locales) {
    if (true) {
      if (!this._messages[locale]) {
        console.warn(`Messages for locale "${locale}" not loaded.`);
      }
    }
    this._locale = locale;
    this._locales = locales;
    this.emit("change");
  }
  _(id, values, options) {
    let message = options == null ? void 0 : options.message;
    if (!isString(id)) {
      values = id.values || values;
      message = id.message;
      id = id.id;
    }
    const messageForId = this.messages[id];
    const messageMissing = messageForId === void 0;
    const missing = this._missing;
    if (missing && messageMissing) {
      return isFunction(missing) ? missing(this._locale, id) : missing;
    }
    if (messageMissing) {
      this.emit("missing", { id, locale: this._locale });
    }
    let translation = messageForId || message || id;
    if (true) {
      translation = isString(translation) ? compileMessage(translation) : translation;
    }
    if (isString(translation) && UNICODE_REGEX.test(translation))
      return JSON.parse(`"${translation}"`);
    if (isString(translation))
      return translation;
    return interpolate(
      translation,
      this._locale,
      this._locales
    )(values, options == null ? void 0 : options.formats);
  }
  date(value, format) {
    return date(this._locales || this._locale, value, format);
  }
  number(value, format) {
    return number(this._locales || this._locale, value, format);
  }
};
function setupI18n(params = {}) {
  return new I18n(params);
}
var i18n = setupI18n();

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/search-16.js
var messages = JSON.parse('{"icon.title.search":"Forst\xF8rrelsesglass"}');
var messages2 = JSON.parse('{"icon.title.search":"Magnifying glass"}');
var messages3 = JSON.parse('{"icon.title.search":"Suurennuslasi"}');
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale2 = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale2;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale2;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages43 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n(messages2, messages, messages3);
var IconSearch16 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Magnifying glass`, id: "icon.title.search", comment: "Title for search icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-search-16-part">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.905 12.102A6.042 6.042 0 1 0 4.18.981a6.042 6.042 0 0 0 4.726 11.121Zm1.909-1.289L15.5 15.5"></path></svg>`;
  }
};
if (!customElements.get("w-icon-search-16")) {
  customElements.define("w-icon-search-16", IconSearch16);
}

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/close-16.js
import { LitElement as LitElement2 } from "lit";
import { unsafeStatic as unsafeStatic2, html as html2 } from "lit/static-html.js";
var messages4 = JSON.parse('{"icon.title.close":"Kryss"}');
var messages22 = JSON.parse('{"icon.title.close":"Cross"}');
var messages32 = JSON.parse('{"icon.title.close":"Rasti"}');
var supportedLocales2 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale3 = "en";
var detectByBrand2 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost2 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale3;
  }
};
var getSupportedLocale2 = (usedLocale) => {
  return supportedLocales2.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost2();
};
function detectLocale2() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand2();
    return getSupportedLocale2(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost2();
    if (!supportedLocales2.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale2(hostLocale);
    }
    return getSupportedLocale2(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale3;
  }
}
var getMessages2 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n2 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale2();
  const messages43 = getMessages2(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n2(messages22, messages4, messages32);
var IconClose16 = class extends LitElement2 {
  render() {
    const title = i18n.t({ message: `Cross`, id: "icon.title.close", comment: "Title for close icon" });
    return html2`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-close-16-part">${unsafeStatic2(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 3.5-9 9m0-9 9 9"></path></svg>`;
  }
};
if (!customElements.get("w-icon-close-16")) {
  customElements.define("w-icon-close-16", IconClose16);
}

// packages/utils/index.js
import { classMap } from "lit/directives/class-map.js";
var camelCaseToKebabCase = (str) => str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
function kebabCaseAttributes(constructor) {
  return class extends constructor {
    static createProperty(name, options) {
      let customOptions = options;
      if (typeof (options == null ? void 0 : options.attribute) === "undefined" || (options == null ? void 0 : options.attribute) === true) {
        customOptions = Object.assign({}, options, {
          attribute: camelCaseToKebabCase(name.toString())
        });
      }
      super.createProperty(name, customOptions);
    }
  };
}
function classes(defn) {
  const classes3 = [];
  for (const [key, value] of Object.entries(defn)) {
    if (value)
      classes3.push(key);
  }
  return classes3.join(" ");
}
function fclasses(definition) {
  const defn = {};
  for (const [key, value] of Object.entries(definition)) {
    for (const className of key.split(" ")) {
      defn[className] = value;
    }
  }
  return classMap(defn);
}
function generateRandomId() {
  return `m${Math.random().toString(36).slice(2)}`;
}

// packages/affix/index.js
var WarpAffix = class extends WarpElement {
  get _classBase() {
    return this.slot === "suffix" ? suffix : prefix;
  }
  get _classes() {
    return fclasses({
      [this._classBase.wrapper]: true,
      [this._classBase.wrapperWithLabel]: this.label,
      [this._classBase.wrapperWithIcon]: !this.label
    });
  }
  get _searchButton() {
    return html3`
      <button aria-label="${ifDefined(this.ariaLabel)}" class="${this._classes}" type="submit">
        <w-icon-search-16></w-icon-search-16>
      </button>
    `;
  }
  get _clearButton() {
    return html3`
      <button aria-label="${ifDefined(this.ariaLabel)}" class="${this._classes}" type="reset">
        <w-icon-close-16></w-icon-close-16>
      </button>
    `;
  }
  get _text() {
    return html3`
      <div class="${this._classes}">
        <span class="${this._classBase.label}">${this.label}</span>
      </div>
    `;
  }
  get _markup() {
    if (this.label) {
      return this._text;
    } else if (this.search) {
      return this._searchButton;
    } else if (this.clear) {
      return this._clearButton;
    }
  }
  render() {
    return html3`${this._markup}`;
  }
};
__publicField(WarpAffix, "styles", [WarpElement.styles]);
__publicField(WarpAffix, "properties", {
  ariaLabel: { type: String, attribute: "aria-label" },
  clear: { type: Boolean },
  search: { type: Boolean },
  label: { type: String }
});
if (!customElements.get("w-affix")) {
  customElements.define("w-affix", WarpAffix);
}

// packages/alert/index.js
import WarpElement2 from "@warp-ds/elements-core";
import { css, html as html8 } from "lit";

// node_modules/.pnpm/@chbphone55+classnames@2.0.0/node_modules/@chbphone55/classnames/dist/index.m.js
var r = function() {
  for (var t2 = [], n3 = arguments.length; n3--; )
    t2[n3] = arguments[n3];
  return t2.reduce(function(t3, n4) {
    return t3.concat("string" == typeof n4 ? n4 : Array.isArray(n4) ? r.apply(void 0, n4) : "object" == typeof n4 && n4 ? Object.keys(n4).map(function(r4) {
      return n4[r4] ? r4 : "";
    }) : "");
  }, []).join(" ");
};

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/info-16.js
import { LitElement as LitElement3 } from "lit";
import { unsafeStatic as unsafeStatic3, html as html4 } from "lit/static-html.js";
var messages5 = JSON.parse('{"icon.title.info":"Informasjonssirkel"}');
var messages23 = JSON.parse('{"icon.title.info":"Information circle"}');
var messages33 = JSON.parse('{"icon.title.info":"Ympyr\xE4, jonka sis\xE4ll\xE4 on i-kirjain"}');
var supportedLocales3 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale4 = "en";
var detectByBrand3 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost3 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale4;
  }
};
var getSupportedLocale3 = (usedLocale) => {
  return supportedLocales3.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost3();
};
function detectLocale3() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand3();
    return getSupportedLocale3(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost3();
    if (!supportedLocales3.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale3(hostLocale);
    }
    return getSupportedLocale3(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale4;
  }
}
var getMessages3 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n3 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale3();
  const messages43 = getMessages3(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n3(messages23, messages5, messages33);
var IconInfo16 = class extends LitElement3 {
  render() {
    const title = i18n.t({ message: `Information circle`, id: "icon.title.info", comment: "Title for info icon" });
    return html4`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-info-16-part">${unsafeStatic3(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" d="M8 6.5v5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 4v.5"></path><path stroke="currentColor" stroke-miterlimit="10" d="M8 .5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"></path></svg>`;
  }
};
if (!customElements.get("w-icon-info-16")) {
  customElements.define("w-icon-info-16", IconInfo16);
}

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/warning-16.js
import { LitElement as LitElement4 } from "lit";
import { unsafeStatic as unsafeStatic4, html as html5 } from "lit/static-html.js";
var messages6 = JSON.parse('{"icon.title.warning":"Varseltrekant med utropstegn"}');
var messages24 = JSON.parse('{"icon.title.warning":"Warning triangle with exclamation point"}');
var messages34 = JSON.parse('{"icon.title.warning":"Varoituskolmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales4 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale5 = "en";
var detectByBrand4 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost4 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale5;
  }
};
var getSupportedLocale4 = (usedLocale) => {
  return supportedLocales4.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost4();
};
function detectLocale4() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand4();
    return getSupportedLocale4(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost4();
    if (!supportedLocales4.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale4(hostLocale);
    }
    return getSupportedLocale4(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale5;
  }
}
var getMessages4 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n4 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale4();
  const messages43 = getMessages4(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n4(messages24, messages6, messages34);
var IconWarning16 = class extends LitElement4 {
  render() {
    const title = i18n.t({ message: `Warning triangle with exclamation point`, id: "icon.title.warning", comment: "Title for warning icon" });
    return html5`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-warning-16-part">${unsafeStatic4(`<title>${title}</title>`)}<path stroke="currentColor" d="m.712 14.07 6.25-12.994a1 1 0 0 1 1.792-.022l6.635 12.995a1 1 0 0 1-.89 1.455H1.613a1 1 0 0 1-.902-1.434Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 6v4.992M8 13v.333"></path></svg>`;
  }
};
if (!customElements.get("w-icon-warning-16")) {
  customElements.define("w-icon-warning-16", IconWarning16);
}

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/error-16.js
import { LitElement as LitElement5 } from "lit";
import { unsafeStatic as unsafeStatic5, html as html6 } from "lit/static-html.js";
var messages7 = JSON.parse('{"icon.title.error":"\xC5ttekant med utropstegn"}');
var messages25 = JSON.parse('{"icon.title.error":"Octagon with exclamation point"}');
var messages35 = JSON.parse('{"icon.title.error":"Kahdeksankulmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales5 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale6 = "en";
var detectByBrand5 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost5 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale6;
  }
};
var getSupportedLocale5 = (usedLocale) => {
  return supportedLocales5.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost5();
};
function detectLocale5() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand5();
    return getSupportedLocale5(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost5();
    if (!supportedLocales5.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale5(hostLocale);
    }
    return getSupportedLocale5(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale6;
  }
}
var getMessages5 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n5 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale5();
  const messages43 = getMessages5(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n5(messages25, messages7, messages35);
var IconError16 = class extends LitElement5 {
  render() {
    const title = i18n.t({ message: `Octagon with exclamation point`, id: "icon.title.error", comment: "Title for error icon" });
    return html6`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-error-16-part">${unsafeStatic5(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 11.107 4.748 15.5h6.503l4.248-4.393V4.893L11.252.5H4.748L.5 4.893z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 11.398a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8 8.5V3"></path></svg>`;
  }
};
if (!customElements.get("w-icon-error-16")) {
  customElements.define("w-icon-error-16", IconError16);
}

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/success-16.js
import { LitElement as LitElement6 } from "lit";
import { unsafeStatic as unsafeStatic6, html as html7 } from "lit/static-html.js";
var messages8 = JSON.parse('{"icon.title.success":"Sirkel med sjekkmerke"}');
var messages26 = JSON.parse('{"icon.title.success":"Circle with checkmark"}');
var messages36 = JSON.parse('{"icon.title.success":"Ympyr\xE4, jonka sis\xE4ll\xE4 on valintamerkki"}');
var supportedLocales6 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale7 = "en";
var detectByBrand6 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost6 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale7;
  }
};
var getSupportedLocale6 = (usedLocale) => {
  return supportedLocales6.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost6();
};
function detectLocale6() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand6();
    return getSupportedLocale6(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost6();
    if (!supportedLocales6.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale6(hostLocale);
    }
    return getSupportedLocale6(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale7;
  }
}
var getMessages6 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n6 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale6();
  const messages43 = getMessages6(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n6(messages26, messages8, messages36);
var IconSuccess16 = class extends LitElement6 {
  render() {
    const title = i18n.t({ message: `Circle with checkmark`, id: "icon.title.success", comment: "Title for success icon" });
    return html7`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-success-16-part">${unsafeStatic6(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m4 8.815 1.633 2.318a.7.7 0 0 0 1.138.034l5.228-6.615"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 7.999a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"></path></svg>`;
  }
};
if (!customElements.get("w-icon-success-16")) {
  customElements.define("w-icon-success-16", IconSuccess16);
}

// packages/alert/index.js
var variants = {
  negative: "negative",
  positive: "positive",
  warning: "warning",
  info: "info"
};
var WarpAlert = class extends WarpElement2 {
  constructor() {
    super();
    this.show = false;
    this.role = "alert";
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.variant || !variants[this.variant]) {
      throw new Error(
        'Invalid "variant" attribute. Set its value to one of the following:\nnegative, positive, warning, info.'
      );
    }
  }
  get _wrapperClasses() {
    return r({
      [alert.alert]: true,
      [alert[this.variant]]: true
    });
  }
  get _iconClasses() {
    const activeIconClassNames = alert[`${this.variant}Icon`];
    return r({
      [alert.icon]: true,
      [activeIconClassNames]: true
    });
  }
  get _icon() {
    if (this.variant === variants.info)
      return html8`<w-icon-info-16></w-icon-info-16>`;
    if (this.variant === variants.warning)
      return html8`<w-icon-warning-16></w-icon-warning-16>`;
    if (this.variant === variants.negative)
      return html8`<w-icon-error-16></w-icon-error-16>`;
    if (this.variant === variants.positive)
      return html8`<w-icon-success-16></w-icon-success-16>`;
    else
      return "";
  }
  render() {
    return html8`
      <w-expand-transition ?show=${this.show}>
        <div role=${this.role} class=${this._wrapperClasses}>
          <div class=${this._iconClasses}>${this._icon}</div>
          <div class=${alert.textWrapper}>
            <slot></slot>
          </div>
        </div>
      </w-expand-transition>
    `;
  }
};
__publicField(WarpAlert, "properties", {
  variant: { type: String, reflect: true },
  show: { type: Boolean, reflect: true },
  role: { type: String, reflect: true }
});
// Slotted elements remain in lightDOM which allows for control of their style outside of shadowDOM.
// ::slotted([Simple Selector]) confirms to Specificity rules, but (being simple) does not add weight to lightDOM skin selectors,
// so never gets higher Specificity. Thus in order to overwrite style linked within shadowDOM, we need to use !important.
// https://stackoverflow.com/a/61631668
__publicField(WarpAlert, "styles", [
  WarpElement2.styles,
  css`
      :host {
        display: block;
      }
      ::slotted(:first-child) {
        margin-top: 0px;
      }
      ::slotted(:last-child) {
        margin-bottom: 0px !important;
      }
    `
]);
if (!customElements.get("w-alert")) {
  customElements.define("w-alert", WarpAlert);
}

// packages/attention/index.js
import { css as css2, html as html9, nothing } from "lit";
import WarpElement3 from "@warp-ds/elements-core";
import { ifDefined as ifDefined2 } from "lit/directives/if-defined.js";

// node_modules/.pnpm/@floating-ui+core@0.7.3/node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t2) {
  return t2.split("-")[0];
}
function e(t2) {
  return t2.split("-")[1];
}
function n(e2) {
  return ["top", "bottom"].includes(t(e2)) ? "x" : "y";
}
function r2(t2) {
  return "y" === t2 ? "height" : "width";
}
function i(i3, o3, a3) {
  let { reference: l3, floating: s3 } = i3;
  const c3 = l3.x + l3.width / 2 - s3.width / 2, f3 = l3.y + l3.height / 2 - s3.height / 2, u3 = n(o3), m3 = r2(u3), g3 = l3[m3] / 2 - s3[m3] / 2, d3 = "x" === u3;
  let p3;
  switch (t(o3)) {
    case "top":
      p3 = { x: c3, y: l3.y - s3.height };
      break;
    case "bottom":
      p3 = { x: c3, y: l3.y + l3.height };
      break;
    case "right":
      p3 = { x: l3.x + l3.width, y: f3 };
      break;
    case "left":
      p3 = { x: l3.x - s3.width, y: f3 };
      break;
    default:
      p3 = { x: l3.x, y: l3.y };
  }
  switch (e(o3)) {
    case "start":
      p3[u3] -= g3 * (a3 && d3 ? -1 : 1);
      break;
    case "end":
      p3[u3] += g3 * (a3 && d3 ? -1 : 1);
  }
  return p3;
}
var o = async (t2, e2, n3) => {
  const { placement: r4 = "bottom", strategy: o3 = "absolute", middleware: a3 = [], platform: l3 } = n3, s3 = await (null == l3.isRTL ? void 0 : l3.isRTL(e2));
  let c3 = await l3.getElementRects({ reference: t2, floating: e2, strategy: o3 }), { x: f3, y: u3 } = i(c3, r4, s3), m3 = r4, g3 = {}, d3 = 0;
  for (let n4 = 0; n4 < a3.length; n4++) {
    const { name: p3, fn: h3 } = a3[n4], { x: y3, y: x3, data: w3, reset: v3 } = await h3({ x: f3, y: u3, initialPlacement: r4, placement: m3, strategy: o3, middlewareData: g3, rects: c3, platform: l3, elements: { reference: t2, floating: e2 } });
    f3 = null != y3 ? y3 : f3, u3 = null != x3 ? x3 : u3, g3 = __spreadProps(__spreadValues({}, g3), { [p3]: __spreadValues(__spreadValues({}, g3[p3]), w3) }), v3 && d3 <= 50 && (d3++, "object" == typeof v3 && (v3.placement && (m3 = v3.placement), v3.rects && (c3 = true === v3.rects ? await l3.getElementRects({ reference: t2, floating: e2, strategy: o3 }) : v3.rects), { x: f3, y: u3 } = i(c3, m3, s3)), n4 = -1);
  }
  return { x: f3, y: u3, placement: m3, strategy: o3, middlewareData: g3 };
};
function a(t2) {
  return "number" != typeof t2 ? function(t3) {
    return __spreadValues({ top: 0, right: 0, bottom: 0, left: 0 }, t3);
  }(t2) : { top: t2, right: t2, bottom: t2, left: t2 };
}
function l(t2) {
  return __spreadProps(__spreadValues({}, t2), { top: t2.y, left: t2.x, right: t2.x + t2.width, bottom: t2.y + t2.height });
}
async function s(t2, e2) {
  var n3;
  void 0 === e2 && (e2 = {});
  const { x: r4, y: i3, platform: o3, rects: s3, elements: c3, strategy: f3 } = t2, { boundary: u3 = "clippingAncestors", rootBoundary: m3 = "viewport", elementContext: g3 = "floating", altBoundary: d3 = false, padding: p3 = 0 } = e2, h3 = a(p3), y3 = c3[d3 ? "floating" === g3 ? "reference" : "floating" : g3], x3 = l(await o3.getClippingRect({ element: null == (n3 = await (null == o3.isElement ? void 0 : o3.isElement(y3))) || n3 ? y3 : y3.contextElement || await (null == o3.getDocumentElement ? void 0 : o3.getDocumentElement(c3.floating)), boundary: u3, rootBoundary: m3, strategy: f3 })), w3 = l(o3.convertOffsetParentRelativeRectToViewportRelativeRect ? await o3.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: "floating" === g3 ? __spreadProps(__spreadValues({}, s3.floating), { x: r4, y: i3 }) : s3.reference, offsetParent: await (null == o3.getOffsetParent ? void 0 : o3.getOffsetParent(c3.floating)), strategy: f3 }) : s3[g3]);
  return { top: x3.top - w3.top + h3.top, bottom: w3.bottom - x3.bottom + h3.bottom, left: x3.left - w3.left + h3.left, right: w3.right - x3.right + h3.right };
}
var c = Math.min;
var f = Math.max;
function u(t2, e2, n3) {
  return f(t2, c(e2, n3));
}
var m = (t2) => ({ name: "arrow", options: t2, async fn(i3) {
  const { element: o3, padding: l3 = 0 } = null != t2 ? t2 : {}, { x: s3, y: c3, placement: f3, rects: m3, platform: g3 } = i3;
  if (null == o3)
    return {};
  const d3 = a(l3), p3 = { x: s3, y: c3 }, h3 = n(f3), y3 = e(f3), x3 = r2(h3), w3 = await g3.getDimensions(o3), v3 = "y" === h3 ? "top" : "left", b3 = "y" === h3 ? "bottom" : "right", R2 = m3.reference[x3] + m3.reference[h3] - p3[h3] - m3.floating[x3], A = p3[h3] - m3.reference[h3], P2 = await (null == g3.getOffsetParent ? void 0 : g3.getOffsetParent(o3));
  let T3 = P2 ? "y" === h3 ? P2.clientHeight || 0 : P2.clientWidth || 0 : 0;
  0 === T3 && (T3 = m3.floating[x3]);
  const O2 = R2 / 2 - A / 2, D3 = d3[v3], L3 = T3 - w3[x3] - d3[b3], k2 = T3 / 2 - w3[x3] / 2 + O2, E3 = u(D3, k2, L3), C2 = ("start" === y3 ? d3[v3] : d3[b3]) > 0 && k2 !== E3 && m3.reference[x3] <= m3.floating[x3];
  return { [h3]: p3[h3] - (C2 ? k2 < D3 ? D3 - k2 : L3 - k2 : 0), data: { [h3]: E3, centerOffset: k2 - E3 } };
} });
var g = { left: "right", right: "left", bottom: "top", top: "bottom" };
function d(t2) {
  return t2.replace(/left|right|bottom|top/g, (t3) => g[t3]);
}
function p(t2, i3, o3) {
  void 0 === o3 && (o3 = false);
  const a3 = e(t2), l3 = n(t2), s3 = r2(l3);
  let c3 = "x" === l3 ? a3 === (o3 ? "end" : "start") ? "right" : "left" : "start" === a3 ? "bottom" : "top";
  return i3.reference[s3] > i3.floating[s3] && (c3 = d(c3)), { main: c3, cross: d(c3) };
}
var h = { start: "end", end: "start" };
function y(t2) {
  return t2.replace(/start|end/g, (t3) => h[t3]);
}
var x = ["top", "right", "bottom", "left"];
var w = x.reduce((t2, e2) => t2.concat(e2, e2 + "-start", e2 + "-end"), []);
var b = function(e2) {
  return void 0 === e2 && (e2 = {}), { name: "flip", options: e2, async fn(n3) {
    var r4;
    const { placement: i3, middlewareData: o3, rects: a3, initialPlacement: l3, platform: c3, elements: f3 } = n3, _a = e2, { mainAxis: u3 = true, crossAxis: m3 = true, fallbackPlacements: g3, fallbackStrategy: h3 = "bestFit", flipAlignment: x3 = true } = _a, w3 = __objRest(_a, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "flipAlignment"]), v3 = t(i3), b3 = g3 || (v3 === l3 || !x3 ? [d(l3)] : function(t2) {
      const e3 = d(t2);
      return [y(t2), e3, y(e3)];
    }(l3)), R2 = [l3, ...b3], A = await s(n3, w3), P2 = [];
    let T3 = (null == (r4 = o3.flip) ? void 0 : r4.overflows) || [];
    if (u3 && P2.push(A[v3]), m3) {
      const { main: t2, cross: e3 } = p(i3, a3, await (null == c3.isRTL ? void 0 : c3.isRTL(f3.floating)));
      P2.push(A[t2], A[e3]);
    }
    if (T3 = [...T3, { placement: i3, overflows: P2 }], !P2.every((t2) => t2 <= 0)) {
      var O2, D3;
      const t2 = (null != (O2 = null == (D3 = o3.flip) ? void 0 : D3.index) ? O2 : 0) + 1, e3 = R2[t2];
      if (e3)
        return { data: { index: t2, overflows: T3 }, reset: { placement: e3 } };
      let n4 = "bottom";
      switch (h3) {
        case "bestFit": {
          var L3;
          const t3 = null == (L3 = T3.map((t4) => [t4, t4.overflows.filter((t5) => t5 > 0).reduce((t5, e4) => t5 + e4, 0)]).sort((t4, e4) => t4[1] - e4[1])[0]) ? void 0 : L3[0].placement;
          t3 && (n4 = t3);
          break;
        }
        case "initialPlacement":
          n4 = l3;
      }
      if (i3 !== n4)
        return { reset: { placement: n4 } };
    }
    return {};
  } };
};
var T = function(r4) {
  return void 0 === r4 && (r4 = 0), { name: "offset", options: r4, async fn(i3) {
    const { x: o3, y: a3 } = i3, l3 = await async function(r5, i4) {
      const { placement: o4, platform: a4, elements: l4 } = r5, s3 = await (null == a4.isRTL ? void 0 : a4.isRTL(l4.floating)), c3 = t(o4), f3 = e(o4), u3 = "x" === n(o4), m3 = ["left", "top"].includes(c3) ? -1 : 1, g3 = s3 && u3 ? -1 : 1, d3 = "function" == typeof i4 ? i4(r5) : i4;
      let { mainAxis: p3, crossAxis: h3, alignmentAxis: y3 } = "number" == typeof d3 ? { mainAxis: d3, crossAxis: 0, alignmentAxis: null } : __spreadValues({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, d3);
      return f3 && "number" == typeof y3 && (h3 = "end" === f3 ? -1 * y3 : y3), u3 ? { x: h3 * g3, y: p3 * m3 } : { x: p3 * m3, y: h3 * g3 };
    }(i3, r4);
    return { x: o3 + l3.x, y: a3 + l3.y, data: l3 };
  } };
};
function O(t2) {
  return "x" === t2 ? "y" : "x";
}
var D = function(e2) {
  return void 0 === e2 && (e2 = {}), { name: "shift", options: e2, async fn(r4) {
    const { x: i3, y: o3, placement: a3 } = r4, _a = e2, { mainAxis: l3 = true, crossAxis: c3 = false, limiter: f3 = { fn: (t2) => {
      let { x: e3, y: n3 } = t2;
      return { x: e3, y: n3 };
    } } } = _a, m3 = __objRest(_a, ["mainAxis", "crossAxis", "limiter"]), g3 = { x: i3, y: o3 }, d3 = await s(r4, m3), p3 = n(t(a3)), h3 = O(p3);
    let y3 = g3[p3], x3 = g3[h3];
    if (l3) {
      const t2 = "y" === p3 ? "bottom" : "right";
      y3 = u(y3 + d3["y" === p3 ? "top" : "left"], y3, y3 - d3[t2]);
    }
    if (c3) {
      const t2 = "y" === h3 ? "bottom" : "right";
      x3 = u(x3 + d3["y" === h3 ? "top" : "left"], x3, x3 - d3[t2]);
    }
    const w3 = f3.fn(__spreadProps(__spreadValues({}, r4), { [p3]: y3, [h3]: x3 }));
    return __spreadProps(__spreadValues({}, w3), { data: { x: w3.x - i3, y: w3.y - o3 } });
  } };
};

// node_modules/.pnpm/@floating-ui+dom@0.5.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function n2(t2) {
  return t2 && t2.document && t2.location && t2.alert && t2.setInterval;
}
function o2(t2) {
  if (null == t2)
    return window;
  if (!n2(t2)) {
    const e2 = t2.ownerDocument;
    return e2 && e2.defaultView || window;
  }
  return t2;
}
function i2(t2) {
  return o2(t2).getComputedStyle(t2);
}
function r3(t2) {
  return n2(t2) ? "" : t2 ? (t2.nodeName || "").toLowerCase() : "";
}
function l2() {
  const t2 = navigator.userAgentData;
  return null != t2 && t2.brands ? t2.brands.map((t3) => t3.brand + "/" + t3.version).join(" ") : navigator.userAgent;
}
function c2(t2) {
  return t2 instanceof o2(t2).HTMLElement;
}
function f2(t2) {
  return t2 instanceof o2(t2).Element;
}
function s2(t2) {
  if ("undefined" == typeof ShadowRoot)
    return false;
  return t2 instanceof o2(t2).ShadowRoot || t2 instanceof ShadowRoot;
}
function u2(t2) {
  const { overflow: e2, overflowX: n3, overflowY: o3 } = i2(t2);
  return /auto|scroll|overlay|hidden/.test(e2 + o3 + n3);
}
function d2(t2) {
  return ["table", "td", "th"].includes(r3(t2));
}
function h2(t2) {
  const e2 = /firefox/i.test(l2()), n3 = i2(t2);
  return "none" !== n3.transform || "none" !== n3.perspective || "paint" === n3.contain || ["transform", "perspective"].includes(n3.willChange) || e2 && "filter" === n3.willChange || e2 && !!n3.filter && "none" !== n3.filter;
}
function a2() {
  return !/^((?!chrome|android).)*safari/i.test(l2());
}
var g2 = Math.min;
var p2 = Math.max;
var m2 = Math.round;
function w2(t2, e2, n3) {
  var i3, r4, l3, s3;
  void 0 === e2 && (e2 = false), void 0 === n3 && (n3 = false);
  const u3 = t2.getBoundingClientRect();
  let d3 = 1, h3 = 1;
  e2 && c2(t2) && (d3 = t2.offsetWidth > 0 && m2(u3.width) / t2.offsetWidth || 1, h3 = t2.offsetHeight > 0 && m2(u3.height) / t2.offsetHeight || 1);
  const g3 = f2(t2) ? o2(t2) : window, p3 = !a2() && n3, w3 = (u3.left + (p3 && null != (i3 = null == (r4 = g3.visualViewport) ? void 0 : r4.offsetLeft) ? i3 : 0)) / d3, v3 = (u3.top + (p3 && null != (l3 = null == (s3 = g3.visualViewport) ? void 0 : s3.offsetTop) ? l3 : 0)) / h3, y3 = u3.width / d3, x3 = u3.height / h3;
  return { width: y3, height: x3, top: v3, right: w3 + y3, bottom: v3 + x3, left: w3, x: w3, y: v3 };
}
function v2(t2) {
  return (e2 = t2, (e2 instanceof o2(e2).Node ? t2.ownerDocument : t2.document) || window.document).documentElement;
  var e2;
}
function y2(t2) {
  return f2(t2) ? { scrollLeft: t2.scrollLeft, scrollTop: t2.scrollTop } : { scrollLeft: t2.pageXOffset, scrollTop: t2.pageYOffset };
}
function x2(t2) {
  return w2(v2(t2)).left + y2(t2).scrollLeft;
}
function b2(t2, e2, n3) {
  const o3 = c2(e2), i3 = v2(e2), l3 = w2(t2, o3 && function(t3) {
    const e3 = w2(t3);
    return m2(e3.width) !== t3.offsetWidth || m2(e3.height) !== t3.offsetHeight;
  }(e2), "fixed" === n3);
  let f3 = { scrollLeft: 0, scrollTop: 0 };
  const s3 = { x: 0, y: 0 };
  if (o3 || !o3 && "fixed" !== n3)
    if (("body" !== r3(e2) || u2(i3)) && (f3 = y2(e2)), c2(e2)) {
      const t3 = w2(e2, true);
      s3.x = t3.x + e2.clientLeft, s3.y = t3.y + e2.clientTop;
    } else
      i3 && (s3.x = x2(i3));
  return { x: l3.left + f3.scrollLeft - s3.x, y: l3.top + f3.scrollTop - s3.y, width: l3.width, height: l3.height };
}
function L2(t2) {
  return "html" === r3(t2) ? t2 : t2.assignedSlot || t2.parentNode || (s2(t2) ? t2.host : null) || v2(t2);
}
function R(t2) {
  return c2(t2) && "fixed" !== getComputedStyle(t2).position ? t2.offsetParent : null;
}
function T2(t2) {
  const e2 = o2(t2);
  let n3 = R(t2);
  for (; n3 && d2(n3) && "static" === getComputedStyle(n3).position; )
    n3 = R(n3);
  return n3 && ("html" === r3(n3) || "body" === r3(n3) && "static" === getComputedStyle(n3).position && !h2(n3)) ? e2 : n3 || function(t3) {
    let e3 = L2(t3);
    for (s2(e3) && (e3 = e3.host); c2(e3) && !["html", "body"].includes(r3(e3)); ) {
      if (h2(e3))
        return e3;
      e3 = e3.parentNode;
    }
    return null;
  }(t2) || e2;
}
function W(t2) {
  if (c2(t2))
    return { width: t2.offsetWidth, height: t2.offsetHeight };
  const e2 = w2(t2);
  return { width: e2.width, height: e2.height };
}
function E2(t2) {
  const e2 = L2(t2);
  return ["html", "body", "#document"].includes(r3(e2)) ? t2.ownerDocument.body : c2(e2) && u2(e2) ? e2 : E2(e2);
}
function H(t2, e2) {
  var n3;
  void 0 === e2 && (e2 = []);
  const i3 = E2(t2), r4 = i3 === (null == (n3 = t2.ownerDocument) ? void 0 : n3.body), l3 = o2(i3), c3 = r4 ? [l3].concat(l3.visualViewport || [], u2(i3) ? i3 : []) : i3, f3 = e2.concat(c3);
  return r4 ? f3 : f3.concat(H(c3));
}
function C(e2, n3, r4) {
  return "viewport" === n3 ? l(function(t2, e3) {
    const n4 = o2(t2), i3 = v2(t2), r5 = n4.visualViewport;
    let l3 = i3.clientWidth, c3 = i3.clientHeight, f3 = 0, s3 = 0;
    if (r5) {
      l3 = r5.width, c3 = r5.height;
      const t3 = a2();
      (t3 || !t3 && "fixed" === e3) && (f3 = r5.offsetLeft, s3 = r5.offsetTop);
    }
    return { width: l3, height: c3, x: f3, y: s3 };
  }(e2, r4)) : f2(n3) ? function(t2, e3) {
    const n4 = w2(t2, false, "fixed" === e3), o3 = n4.top + t2.clientTop, i3 = n4.left + t2.clientLeft;
    return { top: o3, left: i3, x: i3, y: o3, right: i3 + t2.clientWidth, bottom: o3 + t2.clientHeight, width: t2.clientWidth, height: t2.clientHeight };
  }(n3, r4) : l(function(t2) {
    var e3;
    const n4 = v2(t2), o3 = y2(t2), r5 = null == (e3 = t2.ownerDocument) ? void 0 : e3.body, l3 = p2(n4.scrollWidth, n4.clientWidth, r5 ? r5.scrollWidth : 0, r5 ? r5.clientWidth : 0), c3 = p2(n4.scrollHeight, n4.clientHeight, r5 ? r5.scrollHeight : 0, r5 ? r5.clientHeight : 0);
    let f3 = -o3.scrollLeft + x2(t2);
    const s3 = -o3.scrollTop;
    return "rtl" === i2(r5 || n4).direction && (f3 += p2(n4.clientWidth, r5 ? r5.clientWidth : 0) - l3), { width: l3, height: c3, x: f3, y: s3 };
  }(v2(e2)));
}
function S(t2) {
  const e2 = H(t2), n3 = ["absolute", "fixed"].includes(i2(t2).position) && c2(t2) ? T2(t2) : t2;
  return f2(n3) ? e2.filter((t3) => f2(t3) && function(t4, e3) {
    const n4 = null == e3.getRootNode ? void 0 : e3.getRootNode();
    if (t4.contains(e3))
      return true;
    if (n4 && s2(n4)) {
      let n5 = e3;
      do {
        if (n5 && t4 === n5)
          return true;
        n5 = n5.parentNode || n5.host;
      } while (n5);
    }
    return false;
  }(t3, n3) && "body" !== r3(t3)) : [];
}
var D2 = { getClippingRect: function(t2) {
  let { element: e2, boundary: n3, rootBoundary: o3, strategy: i3 } = t2;
  const r4 = [..."clippingAncestors" === n3 ? S(e2) : [].concat(n3), o3], l3 = r4[0], c3 = r4.reduce((t3, n4) => {
    const o4 = C(e2, n4, i3);
    return t3.top = p2(o4.top, t3.top), t3.right = g2(o4.right, t3.right), t3.bottom = g2(o4.bottom, t3.bottom), t3.left = p2(o4.left, t3.left), t3;
  }, C(e2, l3, i3));
  return { width: c3.right - c3.left, height: c3.bottom - c3.top, x: c3.left, y: c3.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t2) {
  let { rect: e2, offsetParent: n3, strategy: o3 } = t2;
  const i3 = c2(n3), l3 = v2(n3);
  if (n3 === l3)
    return e2;
  let f3 = { scrollLeft: 0, scrollTop: 0 };
  const s3 = { x: 0, y: 0 };
  if ((i3 || !i3 && "fixed" !== o3) && (("body" !== r3(n3) || u2(l3)) && (f3 = y2(n3)), c2(n3))) {
    const t3 = w2(n3, true);
    s3.x = t3.x + n3.clientLeft, s3.y = t3.y + n3.clientTop;
  }
  return __spreadProps(__spreadValues({}, e2), { x: e2.x - f3.scrollLeft + s3.x, y: e2.y - f3.scrollTop + s3.y });
}, isElement: f2, getDimensions: W, getOffsetParent: T2, getDocumentElement: v2, getElementRects: (t2) => {
  let { reference: e2, floating: n3, strategy: o3 } = t2;
  return { reference: b2(e2, T2(n3), o3), floating: __spreadProps(__spreadValues({}, W(n3)), { x: 0, y: 0 }) };
}, getClientRects: (t2) => Array.from(t2.getClientRects()), isRTL: (t2) => "rtl" === i2(t2).direction };
var z = (t2, n3, o3) => o(t2, n3, __spreadValues({ platform: D2 }, o3));

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/attention/utils/helpers.js
var TOP = "top";
var BOTTOM = "bottom";
var LEFT = "left";
var RIGHT = "right";
var opposites = {
  [TOP]: BOTTOM,
  [BOTTOM]: TOP,
  [LEFT]: RIGHT,
  [RIGHT]: LEFT
};
var arrowLabels = {
  [TOP]: "\u2191",
  [BOTTOM]: "\u2193",
  [LEFT]: "\u2190",
  [RIGHT]: "\u2192"
};
var rotation = {
  [LEFT]: -45,
  [TOP]: 45,
  [RIGHT]: 135,
  [BOTTOM]: -135
};
var middlePosition = "calc(50% - 7px)";
var isDirectionVertical = (name) => [TOP, BOTTOM].includes(name);
function computeCalloutArrow({ actualDirection, directionName, arrowEl }) {
  if (!arrowEl)
    return;
  actualDirection = directionName;
  const directionIsVertical = isDirectionVertical(directionName);
  arrowEl.style.left = directionIsVertical ? middlePosition : "";
  arrowEl.style.top = !directionIsVertical ? middlePosition : "";
}
async function useRecompute(state) {
  var _a, _b;
  if (!state.isShowing)
    return;
  await ((_a = state == null ? void 0 : state.waitForDOM) == null ? void 0 : _a.call(state));
  if (state.isCallout)
    return computeCalloutArrow(state);
  const position = await z(state.targetEl, state.attentionEl, {
    placement: state.directionName,
    middleware: [
      // Should we make this configurable, but have these as sane defaults?
      b(),
      T(8),
      D({ padding: 16 }),
      // @ts-ignore
      m({ element: state.noArrow ? void 0 : state.arrowEl })
      // FIXME
    ]
  });
  state.actualDirection = position.placement;
  Object.assign(((_b = state.attentionEl) == null ? void 0 : _b.style) || {}, {
    left: "0",
    top: "0",
    transform: `translate3d(${Math.round(position.x)}px, ${Math.round(position.y)}px, 0)`
  });
  let { x: x3, y: y3 } = position.middlewareData.arrow;
  if (state.arrowEl) {
    state.arrowEl.style.left = x3 ? x3 + "px" : "";
    state.arrowEl.style.top = y3 ? y3 + "px" : "";
  }
}

// packages/attention/locales/en/messages.mjs
var messages9 = JSON.parse('{"attention.aria.callout":"callout speech bubble","attention.aria.close":"Close","attention.aria.highlight":"highlighted speech bubble","attention.aria.pointingDown":"pointing down","attention.aria.pointingLeft":"pointing left","attention.aria.pointingRight":"pointing right","attention.aria.pointingUp":"pointing up","attention.aria.popover":"popover speech bubble","attention.aria.tooltip":"tooltip"}');

// packages/attention/locales/nb/messages.mjs
var messages10 = JSON.parse('{"attention.aria.callout":"callout speech bubble","attention.aria.close":"Lukk","attention.aria.highlight":"highlighted speech bubble","attention.aria.pointingDown":"pointing down","attention.aria.pointingLeft":"pointing left","attention.aria.pointingRight":"pointing right","attention.aria.pointingUp":"pointing up","attention.aria.popover":"popover speech bubble","attention.aria.tooltip":"tooltip"}');

// packages/attention/locales/fi/messages.mjs
var messages11 = JSON.parse('{"attention.aria.callout":"callout speech bubble","attention.aria.close":"Sulje","attention.aria.highlight":"highlighted speech bubble","attention.aria.pointingDown":"pointing down","attention.aria.pointingLeft":"pointing left","attention.aria.pointingRight":"pointing right","attention.aria.pointingUp":"pointing up","attention.aria.popover":"popover speech bubble","attention.aria.tooltip":"tooltip"}');

// packages/i18n.ts
var supportedLocales7 = ["en", "nb", "fi"];
var defaultLocale8 = "en";
var getSupportedLocale7 = (usedLocale) => {
  return supportedLocales7.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || defaultLocale8;
};
function detectLocale7() {
  if (typeof window === "undefined") {
    const serverLocale = process.env.NMP_LANGUAGE || Intl.DateTimeFormat().resolvedOptions().locale;
    return getSupportedLocale7(serverLocale);
  }
  try {
    const htmlLocale = document.documentElement.lang;
    return getSupportedLocale7(htmlLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale8;
  }
}
var getMessages7 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n7 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale7();
  const messages43 = getMessages7(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};

// packages/attention/index.js
var WarpAttention = class extends kebabCaseAttributes(WarpElement3) {
  constructor() {
    super();
    activateI18n7(messages9, messages10, messages11);
    this.show = false;
    this.tooltip = false;
    this.callout = false;
    this.popover = false;
    this.highlight = false;
    this.canClose = false;
    this.noArrow = false;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.placement || !Object.keys(opposites).includes(this.placement)) {
      throw new Error(
        `Invalid "placement" attribute. Set its value to one of the following:
${JSON.stringify(
          Object.keys(opposites)
        )}`
      );
    }
    setTimeout(() => this.requestUpdate(), 0);
  }
  get _actualDirection() {
    return this.placement;
  }
  set _actualDirection(v3) {
    this.placement = v3;
  }
  get _arrowDirection() {
    return opposites[this.placement];
  }
  updated() {
    if (!this.callout) {
      this._attentionEl.style.setProperty(
        "--attention-visibility",
        this.show ? "" : "hidden"
      );
    }
    if (!this.tooltip) {
      this._attentionEl.style.setProperty(
        "--attention-display",
        this.show ? "flex" : "none"
      );
    }
    this.attentionState = {
      isShowing: this.show,
      isCallout: this.callout,
      actualDirection: this._actualDirection,
      directionName: this.placement,
      arrowEl: this.renderRoot.querySelector("#arrow"),
      attentionEl: this._attentionEl,
      targetEl: this._targetEl,
      noArrow: this.noArrow
    };
    useRecompute(this.attentionState);
  }
  pointingAtDirection() {
    switch (opposites[this._actualDirection]) {
      case "top":
        return i18n._({
          id: "attention.aria.pointingUp",
          message: "pointing up",
          comment: "Default screenreader message for top direction in the attention component"
        });
      case "right":
        return i18n._({
          id: "attention.aria.pointingRight",
          message: "pointing right",
          comment: "Default screenreader message for right direction in the attention component"
        });
      case "bottom":
        return i18n._({
          id: "attention.aria.pointingDown",
          message: "pointing down",
          comment: "Default screenreader message for bottom direction in the attention component"
        });
      case "left":
        return i18n._({
          id: "attention.aria.pointingLeft",
          message: "pointing left",
          comment: "Default screenreader message for left direction in the attention component"
        });
      default:
        return "";
    }
  }
  activeAttentionType() {
    switch (true) {
      case this.tooltip:
        return i18n._({
          id: "attention.aria.tooltip",
          message: "tooltip",
          comment: "Default screenreader message for tooltip in the attention component"
        });
      case this.callout:
        return i18n._({
          id: "attention.aria.callout",
          message: "callout speech bubble",
          comment: "Default screenreader message for callout speech bubble in the attention component"
        });
      case this.popover:
        return i18n._({
          id: "attention.aria.popover",
          message: "popover speech bubble",
          comment: "Default screenreader message for popover speech bubble in the attention component"
        });
      case this.highlight:
        return i18n._({
          id: "attention.aria.highlight",
          message: "highlighted speech bubble",
          comment: "Default screenreader message for highlighted speech bubble in the attention component"
        });
      default:
        return "";
    }
  }
  defaultAriaLabel() {
    return `${this.activeAttentionType()} ${!this.noArrow ? this.pointingAtDirection() : ""}`;
  }
  setAriaLabels() {
    if (this._targetEl && !this._targetEl.getAttribute("aria-details")) {
      const attentionMessageId = this._messageEl.id || (this._messageEl.id = generateRandomId());
      this._targetEl.setAttribute("aria-details", attentionMessageId);
    }
  }
  get _activeVariantClasses() {
    const variantProps = {
      callout: this.callout,
      popover: this.popover,
      tooltip: this.tooltip,
      highlight: this.highlight
    };
    const activeVariant = Object.keys(variantProps).find((b3) => !!variantProps[b3]) || "";
    return {
      wrapper: attention[activeVariant],
      arrow: attention[`arrow${activeVariant.charAt(0).toUpperCase() + activeVariant.slice(1)}`]
    };
  }
  get _ariaClose() {
    return i18n._({
      id: "attention.aria.close",
      message: "Close",
      comment: "Aria label for the close button in attention"
    });
  }
  firstUpdated() {
    this.setAriaLabels();
    if (this.callout) {
      this._attentionEl.style.position = "relative";
    }
  }
  get _attentionEl() {
    return this.renderRoot.querySelector("#attention");
  }
  get _targetEl() {
    return this.renderRoot.querySelector("slot[name='target']").assignedNodes()[0];
  }
  get _messageEl() {
    return this.renderRoot.querySelector("slot[name='message']").assignedNodes()[0];
  }
  get _wrapperClasses() {
    return classes({
      [attention.base]: true,
      [this._activeVariantClasses.wrapper]: true
    });
  }
  get _arrowClasses() {
    return classes({
      [attention.arrowBase]: true,
      [attention[`arrowDirection${this._arrowDirection.charAt(0).toUpperCase() + this._arrowDirection.slice(1)}`]]: true,
      [this._activeVariantClasses.arrow]: true
    });
  }
  get _arrowHtml() {
    return this.noArrow ? "" : html9`<div
          id="arrow"
          role="img"
          class="${this._arrowClasses}"
          style="transform:rotate(${rotation[this._arrowDirection]}deg);
          margin-${// border alignment is off by a fraction of a pixel, this fixes it
    this._arrowDirection.charAt(0).toLowerCase() + this._arrowDirection.slice(1)}:-0.5px;"
        />`;
  }
  close() {
    const event = new CustomEvent("close", {
      bubbles: true,
      composed: true
    });
    this.updateComplete.then(() => this.dispatchEvent(event));
  }
  keypressed(e2) {
    if (!this.canClose)
      return;
    if (e2.key === "Escape") {
      e2.preventDefault();
      this.close();
    }
  }
  get _closeBtnHtml() {
    return html9`
      <button 
        aria-label="${this._ariaClose}"
        @click="${this.close}"
        @keydown=${this.keypressed}
        class="${attention.closeBtn}"
      >
        <w-icon-close-16 />
      </button>
    `;
  }
  render() {
    return html9`
      <div class=${ifDefined2(this.className ? this.className : void 0)}>
        ${this.placement === "right" || this.placement === "bottom" ? html9`
              <slot name="target"></slot>

              <div
                id="attention"
                role="${this.tooltip ? "tooltip" : "img"}"
                aria-label="${this.defaultAriaLabel()}"
                class="${this._wrapperClasses}"
              >
                ${this._arrowHtml}
                <slot name="message"></slot>
                ${this.canClose ? this._closeBtnHtml : nothing}
              </div>
            ` : html9`
              <div id="attention" class="${this._wrapperClasses}">
                <slot name="message"></slot>
                ${this._arrowHtml}
                ${this.canClose ? this._closeBtnHtml : nothing}
              </div>
              <slot name="target"></slot>
            `}
      </div>
    `;
  }
};
__publicField(WarpAttention, "properties", {
  // Whether Attention element should be visible.
  show: { type: Boolean, reflect: true },
  // Placement according to the target element
  // Arrow would be on the opposite side of this position
  placement: { type: String },
  // Whether Attention element is rendered as a tooltip
  tooltip: { type: Boolean, reflect: true },
  // Whether Attention element is rendered as an inline callout
  callout: { type: Boolean, reflect: true },
  // Whether Attention element is rendered as a popover
  popover: { type: Boolean, reflect: true },
  // Whether Attention element is rendered as a highlight
  highlight: { type: Boolean, reflect: true },
  // Render Attention element with a close button
  canClose: { type: Boolean, reflect: true },
  // Render Attention element without an arrow
  noArrow: { type: Boolean, reflect: true }
});
__publicField(WarpAttention, "styles", [
  WarpElement3.styles,
  css2`
      #attention {
        position: absolute;
        z-index: 50;
        visibility: var(--attention-visibility);
        display: var(--attention-display);
      }

      :host([popover]:not(:popover-open):not(dialog[open])) {
        display: contents;
      }

      #arrow {
        border-top-left-radius: 4px;
        z-index: 1;
      }
    `
]);
if (!customElements.get("w-attention")) {
  customElements.define("w-attention", WarpAttention);
}

// packages/badge/index.js
import { html as html10 } from "lit";
import WarpElement4 from "@warp-ds/elements-core";
var WarpBadge = class extends WarpElement4 {
  constructor() {
    super();
    this.variant = "neutral";
  }
  get _class() {
    return classes({
      [badge.base]: true,
      [badge[this.variant]]: true,
      [badge.positionBase]: !!this.position,
      [badge.positionTL]: this.position === "top-left",
      [badge.positionTR]: this.position === "top-right",
      [badge.positionBR]: this.position === "bottom-right",
      [badge.positionBL]: this.position === "bottom-left"
    });
  }
  render() {
    return html10`
      <div class="${this._class}">
        <slot></slot>
      </div>
    `;
  }
};
__publicField(WarpBadge, "properties", {
  variant: {
    type: "neutral" | "info" | "positive" | "warning" | "negative" | "disabled" | "notification" | "price"
  },
  position: {
    type: "top-left" | "top-right" | "bottom-right" | "bottom-left"
  }
});
__publicField(WarpBadge, "styles", [WarpElement4.styles]);
if (!customElements.get("w-badge")) {
  customElements.define("w-badge", WarpBadge);
}

// packages/box/index.js
import { css as css3, html as html11, nothing as nothing2 } from "lit";
import WarpElement5 from "@warp-ds/elements-core";
var WarpBox = class extends WarpElement5 {
  get _class() {
    return fclasses({
      [box.box]: true,
      [box.bleed]: this.bleed,
      [box.info]: this.info,
      [box.neutral]: this.neutral,
      [box.bordered]: this.bordered
    });
  }
  get _optOutRoleWithDefault() {
    var _a;
    return this.role === "" ? nothing2 : (_a = this.role) != null ? _a : "region";
  }
  render() {
    return html11`
      <div role="${this._optOutRoleWithDefault}" class="${this._class}">
        <slot></slot>
      </div>
    `;
  }
};
__publicField(WarpBox, "properties", {
  bleed: { type: Boolean },
  bordered: { type: Boolean },
  info: { type: Boolean },
  neutral: { type: Boolean },
  role: { type: String }
});
// Slotted elements remain in lightDOM which allows for control of their style outside of shadowDOM.
// ::slotted([Simple Selector]) confirms to Specificity rules, but (being simple) does not add weight to lightDOM skin selectors,
// so never gets higher Specificity. Thus in order to overwrite style linked within shadowDOM, we need to use !important.
// https://stackoverflow.com/a/61631668
__publicField(WarpBox, "styles", [
  WarpElement5.styles,
  css3`
      :host {
        display: block;
      }
      ::slotted(:last-child) {
        margin-bottom: 0 !important;
      }
    `
]);
if (!customElements.get("w-box")) {
  customElements.define("w-box", WarpBox);
}

// packages/breadcrumbs/index.js
import { html as html12 } from "lit";
import WarpElement6 from "@warp-ds/elements-core";

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/breadcrumbs/index.js
function interleave(array, separator2) {
  return array.flatMap((el) => [el, separator2]).slice(0, -1);
}

// packages/breadcrumbs/locales/en/messages.mjs
var messages12 = JSON.parse('{"breadcrumbs.ariaLabel":"You are here"}');

// packages/breadcrumbs/locales/nb/messages.mjs
var messages13 = JSON.parse('{"breadcrumbs.ariaLabel":"Her er du"}');

// packages/breadcrumbs/locales/fi/messages.mjs
var messages14 = JSON.parse('{"breadcrumbs.ariaLabel":"Olet t\xE4ss\xE4"}');

// packages/breadcrumbs/index.js
var separator = html12`<span class=${breadcrumbs.separator}
  >/</span
>`;
var WarpBreadcrumbs = class extends kebabCaseAttributes(WarpElement6) {
  constructor() {
    super();
    activateI18n7(messages12, messages13, messages14);
    this.ariaLabel = i18n._({
      id: "breadcrumbs.ariaLabel",
      message: "You are here",
      comment: "Default screenreader message for the breadcrumb component"
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const flattenedChildren = Array.from(this.children).flat(Infinity).filter((child) => child);
    const styledChildren = flattenedChildren.map((child, index) => {
      if (typeof child === "string") {
        const isLastEl = index === children.length - 1;
        return html12`<span
          class=${breadcrumbs.text}
          aria-current=${isLastEl ? "page" : void 0}
          >${child}</span
        >`;
      }
      child.classList.add(
        child.tagName === "A" ? breadcrumbs.link : breadcrumbs.text
      );
      return child;
    });
    this._children = interleave(styledChildren, separator);
  }
  render() {
    return html12`
      <nav aria-labelledby="breadCrumbLabel">
        <h2 id="breadCrumbLabel" class=${breadcrumbs.a11y}>
          ${this.ariaLabel}
        </h2>
        <div class=${breadcrumbs.wrapper}>${this._children}</div>
      </nav>
    `;
  }
};
__publicField(WarpBreadcrumbs, "styles", [WarpElement6.styles]);
__publicField(WarpBreadcrumbs, "properties", {
  ariaLabel: { type: String }
});
if (!customElements.get("w-breadcrumbs")) {
  customElements.define("w-breadcrumbs", WarpBreadcrumbs);
}

// packages/broadcast/component.js
import { html as html13 } from "lit";
import WarpElement7 from "@warp-ds/elements-core";
import { repeat } from "lit/directives/repeat.js";

// packages/utils/window-exists.js
var windowExists = typeof window !== "undefined";

// packages/broadcast/component.js
var WarpBroadcast = class extends WarpElement7 {
  constructor() {
    super();
    this._messages = [];
    this.interval = 3e4;
    this._hiddenMessageIds = [];
    this.url = windowExists ? window.location.href : "";
  }
  async connectedCallback() {
    super.connectedCallback();
    if (!this.api) {
      console.error('Broadcast "api" attribute invalid or undefined');
      return;
    }
    if (windowExists) {
      await this._fetchMessage();
      setInterval(() => this._fetchMessage(), this.interval);
    }
  }
  async _fetchMessage() {
    const url = `${this.api}?path=${this.url}`;
    try {
      const res = await (await fetch(url)).json();
      this._messages = res.length ? res : [];
    } catch (err) {
      console.error(`failed to fetch broadcasts from given url (${url})`, err);
    }
  }
  async _del(id) {
    const el = this.renderRoot.querySelector(`#broadcast-${id}`);
    await el.collapse();
    this._hiddenMessageIds = [.../* @__PURE__ */ new Set([...this._hiddenMessageIds, id])];
  }
  render() {
    const messages43 = this._messages.filter((item) => !this._hiddenMessageIds.includes(item.id));
    return html13`
      <aside class=${`${messages43.length === 0 ? "hidden" : "mb-16"}`}>
        ${repeat(
      messages43,
      ({ id }) => `broadcast-${id}`,
      ({ id, message }) => html13`<w-toast
              id="broadcast-${id}"
              type="warning"
              text="${message}"
              canclose
              @close=${() => this._del(id)}
            >
            </w-toast>`
    )}
      </aside>
    `;
  }
};
__publicField(WarpBroadcast, "properties", {
  _messages: {
    state: true,
    hasChanged(newVal, oldVal) {
      if (!oldVal || oldVal.length === 0)
        return true;
      const newIds = newVal.map(({ id }) => id).sort();
      const oldIds = oldVal.map(({ id }) => id).sort();
      return JSON.stringify(newIds) !== JSON.stringify(oldIds);
    }
  },
  _hiddenMessageIds: {
    state: true,
    type: Array
  },
  interval: { type: Number, attribute: true, reflect: true },
  url: { type: String, attribute: true, reflect: true },
  api: { type: String, attribute: true, reflect: true }
});
__publicField(WarpBroadcast, "styles", [WarpElement7.styles]);

// packages/broadcast/index.js
if (!customElements.get("w-broadcast")) {
  customElements.define("w-broadcast", WarpBroadcast);
}

// packages/button/index.js
import { html as html14 } from "lit";
import WarpElement8 from "@warp-ds/elements-core";

// packages/button/locales/en/messages.mjs
var messages15 = JSON.parse('{"button.aria.loading":"Loading..."}');

// packages/button/locales/nb/messages.mjs
var messages16 = JSON.parse('{"button.aria.loading":"Laster..."}');

// packages/button/locales/fi/messages.mjs
var messages17 = JSON.parse('{"button.aria.loading":"Ladataan..."}');

// packages/button/index.js
var buttonTypes2 = [
  "primary",
  "secondary",
  "negative",
  "utility",
  "pill",
  "link"
];
var WarpButton = class extends kebabCaseAttributes(WarpElement8) {
  constructor() {
    super();
    activateI18n7(messages15, messages16, messages17);
    this.variant = "secondary";
    this.ariaValueTextLoading = i18n._({
      id: "button.aria.loading",
      message: "Loading...",
      comment: "Screenreader message for buttons that are loading"
    });
  }
  connectedCallback() {
    super.connectedCallback();
    if (!buttonTypes2.includes(this.variant)) {
      throw new Error(
        `Invalid "variant" attribute. Set its value to one of the following:
${buttonTypes2.join(
          ", "
        )}.`
      );
    }
  }
  firstUpdated() {
    if (this.autofocus) {
      setTimeout(() => this.focus(), 0);
    }
  }
  get _classes() {
    const primary = this.variant === "primary";
    const secondary = this.variant === "secondary";
    const negative = this.variant === "negative";
    const utility = this.variant === "utility";
    const pill2 = this.variant === "pill";
    const link = this.variant === "link";
    return r(
      {
        [button.secondary]: secondary && !this.small && !this.quiet && !this.loading,
        [button.secondarySmall]: secondary && this.small && !this.quiet && !this.loading,
        [button.secondarySmallLoading]: secondary && this.small && !this.quiet && this.loading,
        [button.secondarySmallQuiet]: secondary && this.small && this.quiet && !this.loading,
        [button.secondarySmallQuietLoading]: secondary && this.small && this.quiet && this.loading,
        [button.secondaryQuiet]: secondary && !this.small && this.quiet && !this.loading,
        [button.secondaryQuietLoading]: secondary && !this.small && this.quiet && this.loading,
        [button.secondaryLoading]: secondary && !this.small && !this.quiet && this.loading,
        [button.primary]: primary && !this.small && !this.quiet && !this.loading,
        [button.primarySmall]: primary && this.small && !this.quiet && !this.loading,
        [button.primarySmallQuiet]: primary && this.small && this.quiet && !this.loading,
        [button.primarySmallLoading]: primary && this.small && !this.quiet && this.loading,
        [button.primarySmallQuietLoading]: primary && this.small && this.quiet && this.loading,
        [button.primaryQuiet]: primary && !this.small && this.quiet && !this.loading,
        [button.primaryQuietLoading]: primary && !this.small && this.quiet && this.loading,
        [button.primaryLoading]: primary && !this.small && !this.quiet && this.loading,
        [button.utility]: utility && !this.small && !this.quiet && !this.loading,
        [button.utilitySmall]: utility && this.small && !this.quiet && !this.loading,
        [button.utilitySmallQuiet]: utility && this.small && this.quiet && !this.loading,
        [button.utilitySmallLoading]: utility && this.small && !this.quiet && this.loading,
        [button.utilitySmallQuietLoading]: utility && this.small && this.quiet && this.loading,
        [button.utilityQuiet]: utility && !this.small && this.quiet && !this.loading,
        [button.utilityQuietLoading]: utility && !this.small && this.quiet && this.loading,
        [button.utilityLoading]: utility && !this.small && !this.quiet && this.loading,
        [button.negative]: negative && !this.small && !this.quiet && !this.loading,
        [button.negativeSmall]: negative && this.small && !this.quiet && !this.loading,
        [button.negativeSmallQuiet]: negative && this.small && this.quiet && !this.loading,
        [button.negativeSmallLoading]: negative && this.small && !this.quiet && this.loading,
        [button.negativeSmallQuietLoading]: negative && this.small && this.quiet && this.loading,
        [button.negativeQuiet]: negative && !this.small && this.quiet && !this.loading,
        [button.negativeQuietLoading]: negative && !this.small && this.quiet && this.loading,
        [button.negativeLoading]: negative && !this.small && !this.quiet && this.loading,
        [button.pill]: pill2 && !this.small && !this.loading,
        [button.pillSmall]: pill2 && this.small && !this.loading,
        [button.pillLoading]: pill2 && !this.small && this.loading,
        [button.pillSmallLoading]: pill2 && this.small && this.loading,
        [button.link]: link && !this.small,
        [button.linkSmall]: link && this.small,
        [button.linkAsButton]: !!this.href,
        [button.fullWidth]: this.fullWidth,
        [button.contentWidth]: !this.fullWidth
      },
      this.buttonClass
    );
  }
  render() {
    return html14` ${this.href ? html14`<a
          href=${this.href}
          target=${this.target}
          rel=${this.target === "_blank" ? this.rel || "noopener" : void 0}
          class=${this._classes}
        >
          <slot></slot>
        </a>` : html14`<button
          type=${this.type || "button"}
          class=${this._classes}
        >
          <slot></slot>
        </button>`}
    ${this.loading ? html14`<span
          class="sr-only"
          role="progressbar"
          aria-valuenow="{0}"
          aria-valuetext=${this.ariaValueTextLoading}
        />` : null}`;
  }
};
__publicField(WarpButton, "shadowRootOptions", __spreadProps(__spreadValues({}, WarpElement8.shadowRootOptions), {
  delegatesFocus: true
}));
__publicField(WarpButton, "properties", {
  type: { type: "button" | "submit" | "reset", reflect: true },
  autofocus: { type: Boolean, reflect: true },
  variant: { type: String, reflect: true },
  quiet: { type: Boolean, reflect: true },
  small: { type: Boolean, reflect: true },
  loading: { type: Boolean, reflect: true },
  href: { type: String, reflect: true },
  target: { type: String, reflect: true },
  rel: { type: String, reflect: true },
  fullWidth: { type: Boolean, reflect: true },
  buttonClass: { type: String, reflect: true }
});
__publicField(WarpButton, "styles", [WarpElement8.styles]);
if (!customElements.get("w-button")) {
  customElements.define("w-button", WarpButton);
}

// packages/card/index.js
import { html as html15, css as css4 } from "lit";
import WarpElement9 from "@warp-ds/elements-core";
import { ifDefined as ifDefined3 } from "lit/directives/if-defined.js";
var keys = {
  ENTER: "Enter",
  SPACE: " "
};
var WarpCard = class extends WarpElement9 {
  constructor() {
    super();
    this.selected = false;
    this.flat = false;
    this.clickable = false;
  }
  get _outerClasses() {
    return fclasses({
      [card.card]: true,
      [card.cardShadow]: !this.flat,
      [this.selected ? card.cardSelected : card.cardUnselected]: !this.flat,
      [card.cardFlat]: this.flat,
      [this.selected ? card.cardFlatSelected : card.cardFlatUnselected]: this.flat
    });
  }
  get _innerClasses() {
    return fclasses({
      [card.cardOutline]: true,
      [this.selected ? card.cardOutlineSelected : card.cardOutlineUnselected]: true
    });
  }
  get uuButton() {
    return html15`<button
      class="${card.a11y}"
      aria-pressed="${this.selected}"
      tabindex="-1"
    >
      Velg
    </button>`;
  }
  get uuSpan() {
    return html15`<span
      role="checkbox"
      aria-checked="true"
      aria-disabled="true"
    ></span>`;
  }
  keypressed(e2) {
    if (!this.clickable || e2.altKey || e2.ctrlKey)
      return;
    if (e2.key === keys.ENTER || e2.key === keys.SPACE) {
      e2.preventDefault();
      this.click();
    }
  }
  render() {
    return html15`
      <div
        tabindex=${ifDefined3(this.clickable ? "0" : void 0)}
        class="${this._outerClasses}"
        @keydown=${this.keypressed}
      >
        ${this.clickable ? this.uuButton : ""}
        ${!this.clickable && this.selected ? this.uuSpan : ""}
        <div class="${this._innerClasses}"></div>
        <slot></slot>
      </div>
    `;
  }
};
__publicField(WarpCard, "styles", [
  WarpElement9.styles,
  css4`
      a::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      :host {
        display: block;
      }
    `
]);
__publicField(WarpCard, "properties", {
  selected: { type: Boolean, reflect: true },
  flat: { type: Boolean },
  clickable: { type: Boolean }
});
if (!customElements.get("w-card")) {
  customElements.define("w-card", WarpCard);
}

// packages/expandable/index.js
import { css as css5, html as html18 } from "lit";
import WarpElement10 from "@warp-ds/elements-core";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/chevron-down-16.js
import { LitElement as LitElement7 } from "lit";
import { unsafeStatic as unsafeStatic7, html as html16 } from "lit/static-html.js";
var messages18 = JSON.parse('{"icon.title.chevron-down":"Nedoverpil"}');
var messages27 = JSON.parse('{"icon.title.chevron-down":"Downward arrow"}');
var messages37 = JSON.parse('{"icon.title.chevron-down":"Nuoli alasp\xE4in"}');
var supportedLocales8 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale9 = "en";
var detectByBrand7 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost7 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale9;
  }
};
var getSupportedLocale8 = (usedLocale) => {
  return supportedLocales8.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost7();
};
function detectLocale8() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand7();
    return getSupportedLocale8(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost7();
    if (!supportedLocales8.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale8(hostLocale);
    }
    return getSupportedLocale8(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale9;
  }
}
var getMessages8 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n8 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale8();
  const messages43 = getMessages8(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n8(messages27, messages18, messages37);
var IconChevronDown16 = class extends LitElement7 {
  render() {
    const title = i18n.t({ message: `Downward arrow`, id: "icon.title.chevron-down", comment: "Title for chevron-down icon" });
    return html16`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-chevron-down-16-part">${unsafeStatic7(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.667 5.333 5.5 5.5 5.5-5.5"></path></svg>`;
  }
};
if (!customElements.get("w-icon-chevron-down-16")) {
  customElements.define("w-icon-chevron-down-16", IconChevronDown16);
}

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/elements/chevron-up-16.js
import { LitElement as LitElement8 } from "lit";
import { unsafeStatic as unsafeStatic8, html as html17 } from "lit/static-html.js";
var messages19 = JSON.parse('{"icon.title.chevron-up":"Oppoverpil"}');
var messages28 = JSON.parse('{"icon.title.chevron-up":"Upward arrow"}');
var messages38 = JSON.parse('{"icon.title.chevron-up":"Nuoli yl\xF6sp\xE4in"}');
var supportedLocales9 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale10 = "en";
var detectByBrand8 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost8 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale10;
  }
};
var getSupportedLocale9 = (usedLocale) => {
  return supportedLocales9.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost8();
};
function detectLocale9() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand8();
    return getSupportedLocale9(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost8();
    if (!supportedLocales9.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale9(hostLocale);
    }
    return getSupportedLocale9(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale10;
  }
}
var getMessages9 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n9 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale9();
  const messages43 = getMessages9(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages43);
  i18n.activate(locale);
};
activateI18n9(messages28, messages19, messages38);
var IconChevronUp16 = class extends LitElement8 {
  render() {
    const title = i18n.t({ message: `Upward arrow`, id: "icon.title.chevron-up", comment: "Title for chevron-up icon" });
    return html17`<svg xmlns="http://www.w3.org/2000/svg"width="16"height="16"fill="none"viewBox="0 0 16 16" part="w-icon-chevron-up-16-part">${unsafeStatic8(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11 8 5.5l5.5 5.5"></path></svg>`;
  }
};
if (!customElements.get("w-icon-chevron-up-16")) {
  customElements.define("w-icon-chevron-up-16", IconChevronUp16);
}

// packages/expandable/index.js
import { ifDefined as ifDefined4 } from "lit/directives/if-defined.js";
var WarpExpandable = class extends kebabCaseAttributes(WarpElement10) {
  constructor() {
    super();
    this.expanded = false;
    this.animated = false;
    this.info = false;
    this.box = false;
    this.bleed = false;
    this.noChevron = false;
    this._hasTitle = true;
    this._showChevronUp = this.expanded;
  }
  updated(changedProperties) {
    if (changedProperties.has("expanded")) {
      setTimeout(() => {
        this._showChevronUp = this.expanded;
      }, 200);
    }
  }
  firstUpdated() {
    this._hasTitle = !!this.title || this.renderRoot.querySelector("slot[name='title']").assignedNodes().length > 0;
  }
  get _expandableSlot() {
    return html18`<div
      class=${fclasses({
      [this.contentClass || ""]: true,
      [box.box]: this.box,
      [expandable.paddingTop]: this._hasTitle && this.box
    })}
    >
      <slot></slot>
    </div>`;
  }
  get _chevronUpClasses() {
    return fclasses({
      [expandable.elementsTransformChevronUpPart]: true,
      [expandable.elementsChevronUpCollapsePart]: !this.expanded && this._showChevronUp
    });
  }
  get _chevronDownClasses() {
    return fclasses({
      [expandable.elementsTransformChevronDownPart]: true,
      [expandable.elementsChevronDownExpandPart]: this.expanded && !this._showChevronUp
    });
  }
  render() {
    return html18` <div
      class=${fclasses({
      [expandable.expandable]: true,
      [expandable.expandableBox]: this.box,
      [expandable.expandableBleed]: this.bleed
    })}
    >
      ${this._hasTitle ? html18`<w-unstyled-heading level=${this.headingLevel}>
            <button
              type="button"
              aria-expanded="${this.expanded}"
              class=${fclasses({
      [this.buttonClass || ""]: true,
      [expandable.button]: true,
      [expandable.buttonBox]: this.box
    })}
              @click=${() => this.expanded = !this.expanded}
            >
              <div class="${expandable.title}">
                ${this.title ? html18`<span class="${expandable.titleType}"
                      >${this.title}</span
                    >` : html18`<slot name="title"></slot>`}
                ${this.noChevron ? "" : html18`<div
                      class=${fclasses({
      [expandable.chevron]: true,
      [expandable.chevronBox]: this.box,
      [expandable.chevronNonBox]: !this.box
    })}
                    >
                      ${this._showChevronUp ? html18`<w-icon-chevron-up-16
                            class="${this._chevronUpClasses}"
                          ></w-icon-chevron-up-16>` : html18`<w-icon-chevron-down-16
                            class="${this._chevronDownClasses}"
                          ></w-icon-chevron-down-16>`}
                    </div>`}
              </div>
            </button>
          </w-unstyled-heading>` : ""}
      ${this.animated ? html18`<w-expand-transition ?show=${this.expanded}>
            ${this._expandableSlot}
          </w-expand-transition>` : html18`<div
            class=${fclasses({
      [expandable.expansion]: true,
      [expandable.expansionNotExpanded]: !this.expanded
    })}
            aria-hidden=${ifDefined4(!this.expanded ? true : void 0)}
          >
            ${this._expandableSlot}
          </div>`}
    </div>`;
  }
};
__publicField(WarpExpandable, "properties", {
  expanded: { type: Boolean, reflect: true },
  title: { type: String },
  info: { type: Boolean },
  box: { type: Boolean },
  bleed: { type: Boolean },
  buttonClass: { type: String },
  contentClass: { type: String },
  noChevron: { type: Boolean },
  animated: { type: Boolean },
  headingLevel: { type: Number },
  _hasTitle: { type: Boolean, state: true },
  _showChevronUp: { type: Boolean, state: true }
});
// Slotted elements remain in lightDOM which allows for control of their style outside of shadowDOM.
// ::slotted([Simple Selector]) confirms to Specificity rules, but (being simple) does not add weight to lightDOM skin selectors,
// so never gets higher Specificity. Thus in order to overwrite style linked within shadowDOM, we need to use !important.
// https://stackoverflow.com/a/61631668
__publicField(WarpExpandable, "styles", [
  WarpElement10.styles,
  css5`
      :host {
        display: block;
      }
      ::slotted(:last-child) {
        margin-bottom: 0px !important;
      }
      `
]);
if (!customElements.get("w-expandable")) {
  customElements.define("w-expandable", WarpExpandable);
}

// packages/pill/index.js
import { html as html19 } from "lit";

// packages/pill/locales/en/messages.mjs
var messages20 = JSON.parse('{"pill.aria.openFilter":"Open filter","pill.aria.removeFilter":["Remove filter ",["label"]]}');

// packages/pill/locales/fi/messages.mjs
var messages21 = JSON.parse('{"pill.aria.openFilter":"Avaa suodatin","pill.aria.removeFilter":["Tyhjenn\xE4 suodatin ",["label"]]}');

// packages/pill/locales/nb/messages.mjs
var messages29 = JSON.parse('{"pill.aria.openFilter":"\xC5pne filter","pill.aria.removeFilter":["Fjern filter ",["label"]]}');

// packages/pill/index.js
import WarpElement11 from "@warp-ds/elements-core";
var WarpPill = class extends kebabCaseAttributes(WarpElement11) {
  constructor() {
    super();
    activateI18n7(messages20, messages29, messages21);
    this.canClose = false;
    this.suggestion = false;
    this.openFilterSrText = i18n._({
      id: "pill.aria.openFilter",
      message: "Open filter",
      comment: "Fallback screenreader message for open filter"
    });
    this.removeFilterSrText = i18n._({
      id: "pill.aria.removeFilter",
      message: "Remove filter {label}",
      comment: "Fallback screenreader message for removal of the filter"
    });
  }
  get _labelClasses() {
    return r({
      [pill.button]: true,
      [this.suggestion ? pill.suggestion : pill.filter]: true,
      [pill.label]: true,
      [this.canClose ? pill.labelWithClose : pill.labelWithoutClose]: true
    });
  }
  get _closeClasses() {
    return r({
      [pill.button]: true,
      [this.suggestion ? pill.suggestion : pill.filter]: true,
      [pill.close]: true
    });
  }
  _onClick() {
    this.dispatchEvent(new CustomEvent("w-pill-click", { bubbles: true, composed: true }));
  }
  _onClose() {
    this.dispatchEvent(new CustomEvent("w-pill-close", { bubbles: true, composed: true }));
  }
  render() {
    return html19`
      <div class="${pill.pill}">
        <button
          type="button"
          class="${this._labelClasses}"
          @click="${this._onClick}"
        >
          <span class="${pill.a11y}"
            >${this.openSrLabel ? this.openSrLabel : this.openFilterSrText}</span
          >
          <slot></slot>
        </button>
        ${this.canClose ? html19`<button
              type="button"
              class="${this._closeClasses}"
              @click="${this._onClose}"
            >
              <span class="${pill.a11y}"
                >${this.closeSrLabel ? this.closeSrLabel : this.removeFilterSrText}</span
              >
              <w-icon-close-16></w-icon-close-16>
            </button>` : null}
      </div>
    `;
  }
};
__publicField(WarpPill, "styles", [WarpElement11.styles]);
__publicField(WarpPill, "properties", {
  canClose: { type: Boolean },
  suggestion: { type: Boolean },
  openSrLabel: { type: String },
  closeSrLabel: { type: String }
});
if (!customElements.get("w-pill")) {
  customElements.define("w-pill", WarpPill);
}

// packages/select/index.js
import { html as html20, css as css6 } from "lit";
import WarpElement12 from "@warp-ds/elements-core";
import { ifDefined as ifDefined5 } from "lit/directives/if-defined.js";
import { when } from "lit/directives/when.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

// packages/select/locales/en/messages.mjs
var messages30 = JSON.parse('{"select.label.optional":"(optional)"}');

// packages/select/locales/nb/messages.mjs
var messages31 = JSON.parse('{"select.label.optional":"(valgfritt)"}');

// packages/select/locales/fi/messages.mjs
var messages39 = JSON.parse('{"select.label.optional":"(vapaaehtoinen)"}');

// packages/select/index.js
var _classes, classes_get, _helpTextClasses, helpTextClasses_get, _chevronClasses, chevronClasses_get, _id, id_get, _helpId, helpId_get;
var WarpSelect = class extends kebabCaseAttributes(WarpElement12) {
  constructor() {
    super();
    __privateAdd(this, _classes);
    __privateAdd(this, _helpTextClasses);
    __privateAdd(this, _chevronClasses);
    __privateAdd(this, _id);
    __privateAdd(this, _helpId);
    activateI18n7(messages30, messages31, messages39);
    this._options = this.innerHTML;
  }
  render() {
    return html20`<div class="${select.wrapper}">
      ${when(
      this.label,
      () => html20`<label class="${label.label}" for="${__privateGet(this, _id, id_get)}">
            ${this.label}
            ${when(
        this.optional,
        () => html20`<span class="${label.optional}"
                  >${i18n._({
          id: "select.label.optional",
          message: "(optional)",
          comment: "Shown behind label when marked as optional"
        })}</span
                >`
      )}</label
          >`
    )}
      <div class="${select.selectWrapper}">
        <select
          class="${__privateGet(this, _classes, classes_get)}"
          id="${__privateGet(this, _id, id_get)}"
          ?autofocus=${this.autoFocus}
          aria-describedby="${ifDefined5(__privateGet(this, _helpId, helpId_get))}"
          aria-invalid="${ifDefined5(this.invalid)}"
          aria-errormessage="${ifDefined5(this.invalid && __privateGet(this, _helpId, helpId_get))}"
        >
          ${unsafeHTML(this._options)}
        </select>
        <div class="${__privateGet(this, _chevronClasses, chevronClasses_get)}">
          <w-icon-chevron-down-16></w-icon-chevron-down-16>
        </div>
      </div>
      ${when(
      this.always || this.invalid,
      () => html20`<div id="${__privateGet(this, _helpId, helpId_get)}" class="${__privateGet(this, _helpTextClasses, helpTextClasses_get)}">
            ${this.hint}
          </div>`
    )}
    </div>`;
  }
};
_classes = new WeakSet();
classes_get = function() {
  return r({
    [select.default]: true,
    [select.invalid]: this.invalid
  });
};
_helpTextClasses = new WeakSet();
helpTextClasses_get = function() {
  return r({
    [helpText.helpText]: true,
    [helpText.helpTextColor]: !this.invalid,
    [helpText.helpTextColorInvalid]: this.invalid
  });
};
_chevronClasses = new WeakSet();
chevronClasses_get = function() {
  return r({
    [select.chevron]: true,
    [select.chevronDisabled]: this.disabled
  });
};
_id = new WeakSet();
id_get = function() {
  return "select_id";
};
_helpId = new WeakSet();
helpId_get = function() {
  return this.hint ? `${__privateGet(this, _id, id_get)}__hint` : void 0;
};
__publicField(WarpSelect, "properties", {
  // Whether the element should receive focus on render
  autoFocus: { type: Boolean, reflect: true },
  // Renders the field in an invalid state. Often paired with `hint` to provide feedback about the error
  invalid: { type: Boolean, reflect: true },
  // Whether to always show a hint
  always: { type: Boolean, reflect: true },
  // The content displayed as the help text
  hint: { type: String, reflect: true },
  // The content to disply as the label
  label: { type: String, reflect: true },
  // Whether to show optional text
  optional: { type: Boolean, reflect: true },
  _options: { state: true }
});
__publicField(WarpSelect, "styles", [WarpElement12.styles]);
if (!customElements.get("w-select")) {
  customElements.define("w-select", WarpSelect);
}

// packages/textfield/index.js
import { css as css7, html as html21 } from "lit";
import WarpElement13 from "@warp-ds/elements-core";
import { ifDefined as ifDefined6 } from "lit/directives/if-defined.js";
var WarpTextField = class extends WarpElement13 {
  constructor() {
    super();
    this.type = "text";
  }
  get _inputStyles() {
    return fclasses({
      [input.default]: true,
      [input.invalid]: this.invalid,
      [input.disabled]: this.disabled,
      [input.readOnly]: this.readOnly,
      [input.suffix]: this._hasSuffix,
      // we style input with prefix here because we cannot use
      // arbitrary values with commas in UnoCSS like pl-[var(--w-prefix-width, 40px)]
      "warp-input-with-prefix": this._hasPrefix
    });
  }
  get _helpTextStyles() {
    return fclasses({
      [helpText.helpText]: true,
      [helpText.helpTextColor]: !this.invalid,
      [helpText.helpTextColorInvalid]: this.invalid
    });
  }
  get _label() {
    if (this.label) {
      return html21`<label for="${this._id}" class=${label.label}>${this.label}</label>`;
    }
  }
  get _helpId() {
    if (this.helpText)
      return `${this._id}__hint`;
  }
  get _id() {
    return "textfield";
  }
  get _error() {
    if (this.invalid && this._helpId)
      return this._helpId;
  }
  handler(e2) {
    const { name, value } = e2.target;
    const event = new CustomEvent(e2.type, {
      detail: {
        name,
        value,
        target: e2.target
      }
    });
    this.dispatchEvent(event);
  }
  prefixSlotChange(e2) {
    const el = this.renderRoot.querySelector("slot[name=prefix]");
    const affixes = el.assignedElements();
    if (affixes.length)
      this._hasPrefix = true;
  }
  suffixSlotChange(e2) {
    const el = this.renderRoot.querySelector("slot[name=suffix]");
    const affixes = el.assignedElements();
    if (affixes.length)
      this._hasSuffix = true;
  }
  render() {
    return html21`
      ${this._label}
      <div class="${input.wrapper}">
        <slot @slotchange="${this.prefixSlotChange}" name="prefix"></slot>
        <input
          class="${this._inputStyles}"
          type="${this.type}"
          min="${ifDefined6(this.min)}"
          max="${ifDefined6(this.max)}"
          size="${ifDefined6(this.size)}"
          minlength="${ifDefined6(this.minLength)}"
          maxlength="${ifDefined6(this.maxLength)}"
          name="${ifDefined6(this.name)}"
          pattern="${ifDefined6(this.pattern)}"
          placeholder="${ifDefined6(this.placeholder)}"
          value="${ifDefined6(this.value)}"
          aria-describedby="${ifDefined6(this._helpId)}"
          aria-errormessage="${ifDefined6(this._error)}"
          aria-invalid="${ifDefined6(this.invalid)}"
          id="${this._id}"
          ?disabled="${this.disabled}"
          ?readonly="${this.readOnly}"
          ?required="${this.required}"
          @blur="${this.handler}"
          @change="${this.handler}"
          @focus="${this.handler}"
        />
        <slot @slotchange="${this.suffixSlotChange}" name="suffix"></slot>
      </div>
      ${this.helpText && html21`<div class="${this._helpTextStyles}" id="${this._helpId}">${this.helpText}</div>`}
    `;
  }
};
__publicField(WarpTextField, "properties", {
  disabled: { type: Boolean },
  invalid: { type: Boolean },
  id: { type: String },
  label: { type: String },
  helpText: { type: String, attribute: "help-text" },
  size: { type: String },
  max: { type: Number },
  min: { type: Number },
  minLength: { type: Number, attribute: "min-length" },
  maxLength: { type: Number, attribute: "max-length" },
  name: { type: String },
  pattern: { type: String },
  placeholder: { type: String },
  readOnly: { type: Boolean, attribute: "read-only" },
  required: { type: Boolean },
  type: { type: String },
  value: { type: String },
  _hasPrefix: { state: true },
  _hasSuffix: { state: true }
});
// Slotted elements remain in lightDOM which allows for control of their style outside of shadowDOM.
// ::slotted([Simple Selector]) confirms to Specificity rules, but (being simple) does not add weight to lightDOM skin selectors,
// so never gets higher Specificity. Thus in order to overwrite style linked within shadowDOM, we need to use !important.
// https://stackoverflow.com/a/61631668
__publicField(WarpTextField, "styles", [
  WarpElement13.styles,
  css7`
      :host {
        display: block;
      }
      ::slotted(:last-child) {
        margin-bottom: 0px !important;
      }
      .warp-input-with-prefix {
        padding-left:var(--w-prefix-width, 40px);
      }
    `
]);
if (!customElements.get("w-textfield")) {
  customElements.define("w-textfield", WarpTextField);
}

// packages/toast/api.js
function toast2(message, options) {
  if (!windowExists)
    return;
  const toast3 = customElements.get("w-toast-container").init();
  const data = __spreadValues({
    id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5),
    text: message,
    duration: 5e3,
    type: "success"
  }, options);
  toast3.set(data);
  return data;
}
function removeToast(id) {
  if (!windowExists)
    return;
  const toast3 = customElements.get("w-toast-container").init();
  return toast3.del(id);
}
function updateToast(id, options) {
  if (!windowExists)
    return;
  const toast3 = customElements.get("w-toast-container").init();
  toast3.set(__spreadValues(__spreadValues({}, toast3.get(id)), options));
  return toast3.get(id);
}

// packages/toast/toast-container.js
import { css as css8, html as html22 } from "lit";
import WarpElement14 from "@warp-ds/elements-core";
import { repeat as repeat2 } from "lit/directives/repeat.js";
var WarpToastContainer = class extends WarpElement14 {
  constructor() {
    super();
    this._toasts = /* @__PURE__ */ new Map();
  }
  connectedCallback() {
    super.connectedCallback();
    this._interval = setInterval(() => {
      const keep = [];
      const remove = [];
      for (const toast3 of this._toasts) {
        if (Date.now() <= toast3[1].duration)
          keep.push(toast3);
        else
          remove.push(toast3);
      }
      const collapseTasks = [];
      for (const [id] of remove) {
        const el = this.renderRoot.querySelector(`#${id}`);
        collapseTasks.push(el.collapse());
      }
      Promise.all(collapseTasks).then(() => {
        if (keep.length != this._toasts.size)
          this._toasts = new Map(keep);
      });
    }, 500);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._interval)
      clearTimeout(this._interval);
  }
  static init() {
    let el = document.querySelector("w-toast-container");
    if (!el) {
      el = document.createElement("w-toast-container");
      document.body.appendChild(el);
    }
    return el;
  }
  get _toastsArray() {
    return Array.from(this._toasts).map(([, toast3]) => toast3);
  }
  /**
   *
   * @param {String|Number} id
   * @returns {ToastOptions}
   */
  get(id) {
    if (!id)
      throw new Error('undefined "id" given when attempting to retrieve toast');
    if (typeof id !== "string" && !Number.isInteger(id))
      throw new Error(
        '"id" must be number or string when attempting to retrieve toast'
      );
    return this._toasts.get(id);
  }
  /**
   *
   * @param {Object} toast
   * @returns {WarpToastContainer}
   */
  set(toast3) {
    if (!toast3.id)
      throw new Error('invalid or undefined "id" on toast object');
    const result = this._toasts.set(toast3.id, __spreadProps(__spreadValues({}, toast3), {
      duration: Date.now() + (toast3.duration || 5e3)
    }));
    this._toasts = new Map(Array.from(this._toasts));
    return result;
  }
  /**
   *
   * @param {String|Number} id
   * @returns {ToastOptions | false}
   */
  async del(id) {
    if (!id)
      throw new Error('undefined "id" given when attempting to retrieve toast');
    if (typeof id !== "string" && !Number.isInteger(id))
      throw new Error(
        '"id" must be number or string when attempting to retrieve toast'
      );
    const el = this.renderRoot.querySelector(`#${id}`);
    if (!this._toasts.has(id))
      return false;
    await el.collapse();
    const result = this._toasts.delete(id);
    this._toasts = new Map(Array.from(this._toasts));
    return result;
  }
  render() {
    return html22`
      <aside class="${toaster.container}">
        <div class="${toaster.toaster}" id="w-toast-container-list">
          ${repeat2(
      this._toastsArray,
      (toast3) => toast3.id,
      (toast3) => html22` <w-toast
                class="${toaster.content}"
                id="${toast3.id}"
                type="${toast3.type}"
                text="${toast3.text}"
                ?canclose=${toast3.canclose}
                @close=${() => this.del(toast3.id)}
              >
              </w-toast>`
    )}
        </div>
      </aside>
    `;
  }
};
__publicField(WarpToastContainer, "styles", [
  WarpElement14.styles,
  css8`
      :host {
        display: block;
      }
    `
]);
__publicField(WarpToastContainer, "properties", {
  _toasts: { state: true }
});
if (!customElements.get("w-toast-container")) {
  customElements.define("w-toast-container", WarpToastContainer);
}

// packages/toast/toast.js
import { css as css9, html as html23 } from "lit";
import WarpElement15 from "@warp-ds/elements-core";
import { classMap as classMap2 } from "lit/directives/class-map.js";
import { when as when2 } from "lit/directives/when.js";

// node_modules/.pnpm/element-collapse@1.1.0/node_modules/element-collapse/index.js
var windowExists2 = typeof window !== "undefined";
var prefersMotion = true;
if (windowExists2) {
  const query = window.matchMedia("(prefers-reduced-motion: reduce)");
  const callback = ({ matches }) => prefersMotion = !matches;
  if (query.addEventListener)
    query.addEventListener("change", callback);
  callback(query);
}
var removeTransition = (el) => {
  el.style.transition = null;
  el.style.backfaceVisibility = null;
  el.style.overflow = null;
};
var addTransition = (el) => {
  const timing = prefersMotion ? "var(--f-expansion-duration, 0.3s)" : "0.01s";
  el.style.transition = `height ${timing}`;
  el.style.backfaceVisibility = "hidden";
  el.style.overflow = "hidden";
};
var getAfterExpandCallback = (el, done) => () => {
  el.style.height = "auto";
  el.style.overflow = null;
  if (done)
    done();
};
var getAfterCollapseCallback = (done) => () => {
  if (done)
    done();
};
var expand = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r4) => {
        done = r4;
      });
  })();
  const afterExpandCallback = getAfterExpandCallback(el, done);
  removeTransition(el);
  el.style.height = "auto";
  let dest = el.scrollHeight;
  windowExists2 && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterExpandCallback, { once: true });
    el.style.height = "0px";
    el.style.transitionTimingFunction = "ease-out";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = dest + "px");
  });
  if (returnPromise)
    return returnPromise;
};
var collapse = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r4) => {
        done = r4;
      });
  })();
  const afterCollapseCallback = getAfterCollapseCallback(done);
  removeTransition(el);
  let original = el.scrollHeight;
  windowExists2 && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterCollapseCallback, { once: true });
    el.style.height = original + "px";
    el.style.transitionTimingFunction = "ease-in";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = "0px");
  });
  if (returnPromise)
    return returnPromise;
};

// packages/toast/locales/en/messages.mjs
var messages40 = JSON.parse('{"toast.aria.error":"Error","toast.aria.successful":"Successful","toast.aria.warning":"Warning"}');

// packages/toast/locales/nb/messages.mjs
var messages41 = JSON.parse('{"toast.aria.error":"Varsel","toast.aria.successful":"Vellykket","toast.aria.warning":"Feil"}');

// packages/toast/locales/fi/messages.mjs
var messages42 = JSON.parse('{"toast.aria.error":"Error","toast.aria.successful":"Successful","toast.aria.warning":"Warning"}');

// packages/toast/toast.js
var classes2 = (definition) => {
  const defn = {};
  for (const [key, value] of Object.entries(definition)) {
    for (const className of key.split(" ")) {
      defn[className] = value;
    }
  }
  return classMap2(defn);
};
var toastType = {
  success: "success",
  error: "error",
  warning: "warning"
};
var WarpToast = class extends WarpElement15 {
  constructor() {
    super();
    activateI18n7(messages40, messages41, messages42);
    this.id = Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
    this.type = "success";
    this.text = "";
    this.canclose = false;
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  updated() {
    if (!this._expanded && this._wrapper)
      expand(this._wrapper, () => this._expanded = true);
  }
  get _primaryClasses() {
    return classes2({
      [toast.toast]: true,
      [toast.positive]: this.type === toastType.success,
      [toast.warning]: this.type === toastType.warning,
      [toast.negative]: this.type === toastType.error
    });
  }
  get _iconClasses() {
    return classes2({
      [toast.icon]: true,
      [toast.iconPositive]: this.type == toastType.success,
      [toast.iconWarning]: this.type === toastType.warning,
      [toast.iconNegative]: this.type === toastType.error
    });
  }
  get _wrapper() {
    var _a, _b;
    return (_b = (_a = this.renderRoot) == null ? void 0 : _a.querySelector(`section`)) != null ? _b : null;
  }
  get _warning() {
    return this.type === toastType.warning;
  }
  get _error() {
    return this.type === toastType.error;
  }
  get _role() {
    return this._error || this._warning ? "alert" : "status";
  }
  get _typeLabel() {
    if (this._warning)
      return i18n._({
        id: "toast.aria.warning",
        message: "Warning",
        comment: "Default screenreader message for warning in toast component"
      });
    if (this._error)
      return i18n._({
        id: "toast.aria.error",
        message: "Error",
        comment: "Default screenreader message for error in toast component"
      });
    return i18n._({
      id: "toast.aria.successful",
      message: "Successful",
      comment: "Default screenreader message for successful in toast component"
    });
  }
  get _iconMarkup() {
    if (this._warning)
      return html23`<w-icon-warning-16></w-icon-warning-16>`;
    if (this._error)
      return html23`<w-icon-error-16></w-icon-error-16>`;
    else
      return html23`<w-icon-success-16></w-icon-success-16>`;
  }
  async collapse() {
    return new Promise((resolve) => {
      if (this._expanded && this._wrapper)
        collapse(this._wrapper, resolve);
      else
        resolve();
    });
  }
  close() {
    const event = new CustomEvent("close", {
      detail: { id: this.id },
      bubbles: true,
      composed: true
    });
    this.updateComplete.then(() => this.dispatchEvent(event));
  }
  render() {
    if (!this.text)
      return html23``;
    return html23` <section class="${toast.wrapper}" aria-label="${this._typeLabel}">
      <div class="${this._primaryClasses}">
        <div class="${this._iconClasses}">${this._iconMarkup}</div>
        <div role="${this._role}" class="${toast.content}">
          <p>${this.text}</p>
        </div>
        ${when2(
      this.canclose === true,
      () => html23`
            <button class="${toast.close}" @click="${this.close}">
              <w-icon-close-16></w-icon-close-16>
            </button>
          `
    )}
      </div>
    </section>`;
  }
};
__publicField(WarpToast, "styles", [
  WarpElement15.styles,
  css9`
      :host {
        display: block;
      }
    `
]);
__publicField(WarpToast, "properties", {
  id: { type: String, attribute: true, reflect: true },
  type: { type: String, attribute: true, reflect: true },
  text: { type: String, attribute: true, reflect: true },
  canclose: { type: Boolean, attribute: true, reflect: true }
});
if (!customElements.get("w-toast")) {
  customElements.define("w-toast", WarpToast);
}

// packages/utils/expand-transition.js
import { css as css10, html as html24 } from "lit";
import WarpElement16 from "@warp-ds/elements-core";
import { ifDefined as ifDefined7 } from "lit/directives/if-defined.js";
var ExpandTransition = class extends WarpElement16 {
  constructor() {
    super();
    this.show = false;
    this._mounted = false;
    this._removeElement = false;
  }
  willUpdate() {
    if (!this._mounted) {
      this._removeElement = !this.show;
    }
    if (this.show && this._removeElement) {
      this._removeElement = false;
    }
  }
  updated() {
    if (!this._wrapper)
      return;
    if (!this._mounted) {
      this._mounted = true;
      return;
    }
    if (this.show) {
      expand(this._wrapper);
    }
    if (!this.show && !this._removeElement) {
      collapse(this._wrapper, () => this._removeElement = true);
    }
  }
  get _wrapper() {
    return this != null ? this : null;
  }
  render() {
    return html24`<div aria-hidden=${ifDefined7(!this.show ? "true" : void 0)}>
      ${this._removeElement ? html24`` : html24`<slot></slot>`}
    </div>`;
  }
};
__publicField(ExpandTransition, "properties", {
  show: {
    type: Boolean,
    reflect: true
  },
  _removeElement: { type: Boolean, state: true }
});
__publicField(ExpandTransition, "styles", [
  WarpElement16.styles,
  css10`
      :host {
        display: block;
      }
    `
]);
if (!customElements.get("w-expand-transition")) {
  customElements.define("w-expand-transition", ExpandTransition);
}

// packages/utils/unstyled-heading.js
import { html as html25 } from "lit";
import WarpElement17 from "@warp-ds/elements-core";
import { unsafeHTML as unsafeHTML2 } from "lit/directives/unsafe-html.js";
var UnstyledHeading = class extends WarpElement17 {
  get _markup() {
    return `<h${this.level}
    style="margin: 0; font-weight: unset; font-size: unset; line-height: unset;"
  >
    <slot></slot>
  </h${this.level}>
`;
  }
  render() {
    return !this.level ? html25`<slot></slot>` : unsafeHTML2(this._markup);
  }
};
__publicField(UnstyledHeading, "properties", {
  level: { type: Number }
});
__publicField(UnstyledHeading, "styles", [WarpElement17.styles]);
if (!customElements.get("w-unstyled-heading")) {
  customElements.define("w-unstyled-heading", UnstyledHeading);
}
export {
  ExpandTransition,
  UnstyledHeading,
  WarpAffix,
  WarpAlert,
  WarpAttention,
  WarpBadge,
  WarpBox,
  WarpBreadcrumbs,
  WarpBroadcast,
  WarpButton,
  WarpCard,
  WarpExpandable,
  WarpPill,
  WarpSelect,
  WarpTextField,
  WarpToast,
  WarpToastContainer,
  removeToast,
  toast2 as toast,
  updateToast
};
//# sourceMappingURL=index.js.map
